// https://minify-js.com/
import { animate, scroll, inView, stagger } from "https://cdn.jsdelivr.net/npm/motion@latest/+esm";
import { $4, $$4, $id4, isRTL, formatMoney, debounce, getterAdd, getterGet, getterRunFn, btnTooltip, Drawer, VariantChangeBase } from "@theme/global";
// import{QuantitySelectorUpdateEvent}from"@theme/events";
// WISHLIST
var $wishlist_list = $id4('hdt_wishlist_list'),
  $compare_list = $id4('hdt_compare_list'),
  nameCachedWishlist = 'theme4:wishlist:id',
  nameCachedCompare = 'theme4:compare:id';
// if exit $wishlist_list is use app wishlist the4
if ($wishlist_list) {
  var arr_wishlist_list = $wishlist_list.textContent ? $wishlist_list.textContent.split(' ') : [];
}
else {
  var arr_wishlist_list = (!localStorage.getItem(nameCachedWishlist)) ? [] : localStorage.getItem(nameCachedWishlist).split(',');  // remove id: and conver array
}
if ($compare_list){
  var arr_compare_list = $compare_list.textContent ? $compare_list.textContent.split(' ') : [];
}
else {
  var arr_compare_list = (!localStorage.getItem(nameCachedCompare)) ? [] : localStorage.getItem(nameCachedCompare).split(',');  // remove id: and conver array
}
// arr_wishlist_list = [1234, 5678, 9011]
// arr_compare_list = [1234, 5678, 9011]

var linkWishlistApp = '/apps/ecomrise/wishlist',
  linkCompareApp = '/apps/ecomrise/compare',
  actionAfterWishlistAdded = themeHDN.extras.AddedWishlistRemove ? 'remove' : 'added',
  actionAfterCompareAdded = themeHDN.extras.AddedCompareRemove ? 'remove' : 'added',
  limitWishlist = $wishlist_list ? 100 : 50,
  limitCompare = 6,
  conver_to_link_fn = function (prefix = this.textFn, array = this.array) {
    const x = themeHDN.routes.search_url + `/?view=${prefix}`,
      y = x + '&type=product&options[unavailable_products]=last&q=';
    return (array.length) ? y + encodeURI(`id:${array.join(' OR id:')}`) : x;
  };
// Reset if limit change
if (arr_wishlist_list.length > limitWishlist) {
  arr_wishlist_list.splice(limitWishlist - 1, arr_wishlist_list.length - 1);
  localStorage.setItem(nameCachedWishlist, arr_wishlist_list.toString());
}
// Check is page has item but not show reload page
if (window.isPageWishlist) {
  if (arr_wishlist_list.length && !window.isWishlistPerformed) {
    window.location.href = conver_to_link_fn('wishlist', arr_wishlist_list)
  } else {
    window.history.replaceState({}, document.title, conver_to_link_fn('wishlist', []));
  }
  themeHDN.wisHref = conver_to_link_fn('wishlist', arr_wishlist_list);
}

// Reset if limit change
if (arr_compare_list.length > limitCompare) {
  arr_compare_list.splice(limitCompare - 1, arr_compare_list.length - 1);
  localStorage.setItem(nameCachedCompare, arr_compare_list.toString());
}
// Check is page has item but not show reload page
if (window.isPageCompare) {
  if (arr_compare_list.length && !window.isComparePerformed) {
    window.location.href = conver_to_link_fn('compare', arr_compare_list)
  } else {
    window.history.replaceState({}, document.title, conver_to_link_fn('compare', []));
  }
}
var _wishlist_id, _wishlist_handle,
  _update_wis_text, update_wis_text_fn,
  _update_wis_btns, update_wis_btns_fn,
  _click_wis, click_wis_fn,
  _add_wis, add_wis_fn,
  _remove_wis, remove_wis_fn,
  _action_after_remove_add, action_after_remove_add_fn,
  _show_popup_compare, show_popup_compare_fn,
  _conver_to_link;
class Wishlist extends btnTooltip {
  constructor() {
    super();
    getterAdd(_wishlist_id, this, this.dataset.id);
    getterAdd(_wishlist_handle, this, this.dataset.handle);
    getterAdd(_update_wis_text, this);
    getterAdd(_update_wis_btns, this);
    getterAdd(_click_wis, this);
    getterAdd(_add_wis, this);
    getterAdd(_remove_wis, this);
    getterAdd(_action_after_remove_add, this);
    getterAdd(_show_popup_compare, this);
    getterAdd(_conver_to_link, this);
    this.tabIndex = 0;
    this.addEventListener("click", () => getterRunFn(_click_wis, this, click_wis_fn).call(this));
    this.addEventListener("keydown", (event) => {
      if (event.key == "Enter") getterRunFn(_click_wis, this, click_wis_fn).call(this)
    });
  }
  static get observedAttributes() {
    return ["action"];
  }
  get isFnWishlist() {
    return true;
  }
  get textFn() {
    return 'wishlist';
  }
  get isPageWishlistorCompare() {
    //add code check page
    return this.isFnWishlist ? window.isPageWishlist : window.isPageCompare;
  }
  get limit() {
    return this.isFnWishlist ? limitWishlist : limitCompare;
  }
  get nameCached() {
    return this.isFnWishlist ? nameCachedWishlist : nameCachedCompare;
  }
  get array() {
    return this.isFnWishlist ? arr_wishlist_list : arr_compare_list;
  }
  get actionAfterAdded() {
    return this.isFnWishlist ? actionAfterWishlistAdded : actionAfterCompareAdded;
  }
  get action() {
    return this.getAttribute('action');
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue || (oldValue === null && newValue === 'add')) return;
    getterRunFn(_update_wis_text, this, update_wis_text_fn).call(this, newValue);
    super.attributeChangedCallback(name, oldValue, newValue);
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.array.indexOf(getterGet(_wishlist_id, this)) > -1) {
      if (this.hasAttribute('remove-on-page')) {
        return
      }
      this.setAttribute('action', this.actionAfterAdded);
    }
  }
};
_wishlist_id = new WeakMap();
_wishlist_handle = new WeakMap();
_update_wis_text = new WeakSet();
_update_wis_btns = new WeakSet();
_click_wis = new WeakSet();
_add_wis = new WeakSet();
_remove_wis = new WeakSet();
_action_after_remove_add = new WeakSet();
_conver_to_link = new WeakSet();
_show_popup_compare = new WeakSet();
update_wis_text_fn = function (value) {
  if (this.hasAttribute('remove-on-page')) return;
  const text = themeHDN.extras[`text_${this.isFnWishlist ? 'wis' : 'cp'}_${value}`],
    icon = themeHDN.extras[`icon_${this.isFnWishlist ? 'wis' : 'cp'}_${value}`];
  if (icon) this.firstElementChild.replaceWith(document.createRange().createContextualFragment(icon));
  if (text) {
    this.lastElementChild.textContent = text;
    this.setAttribute('data-txt-tt',text)
  }
};
update_wis_btns_fn = function (_action) {
  // Update Button
  $$4(`hdt-${this.textFn}[data-id="${getterGet(_wishlist_id, this)}"]`).forEach(btn => {
    btn.setAttribute('action', _action);
  });
  // Update Count and link
  document.dispatchEvent(new CustomEvent(`theme4:${this.textFn}:update`, {
    bubbles: true,
    detail: 'the4'  // arr_wishlist_list
  }));
  if ((window.isPageWishlist)) themeHDN.wisHref = conver_to_link_fn('wishlist', arr_wishlist_list);
};
click_wis_fn = function (e) {
  if (this.action == 'add') {
    // ADD
    getterRunFn(_add_wis, this, add_wis_fn).call(this);
  } else if (this.action === 'added') {
    // ADDED: go to page wishlist
    if (!this.isFnWishlist && themeHDN.extras.enableComparePopup) {
      getterRunFn(_show_popup_compare, this, show_popup_compare_fn).call(this);
    } else {
      window.location.href = getterRunFn(_conver_to_link, this, conver_to_link_fn).call(this);
    }
  } else {
    // REMOVE
    getterRunFn(_remove_wis, this, remove_wis_fn).call(this);
  }
};
add_wis_fn = function (e) {
  if ($wishlist_list && this.isFnWishlist || $compare_list && !this.isFnWishlist) {
    // app wishlist
    this.setAttribute('aria-busy', true);
    fetch(this.isFnWishlist ? linkWishlistApp : linkCompareApp, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        product_id: getterGet(_wishlist_id, this),
        product_handle: getterGet(_wishlist_handle, this),
        action: 'add'
      })
    })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      if (data.status != 'success') {
        console.error(data.message || 'Unknow error');
        return;
      }
      if(this.isFnWishlist) {
        arr_wishlist_list = JSON.parse(data.response.metafield.value).ecomrise_ids;
        if (!Array.isArray(arr_wishlist_list)) {
          arr_wishlist_list = arr_wishlist_list.split(',');
        }
      }
      if (!this.isFnWishlist) {
        arr_compare_list = JSON.parse(data.response.metafield.value).ecomrise_ids;
        if (!Array.isArray(arr_compare_list)) {
          arr_compare_list = arr_compare_list.split(',');
        }
        getterRunFn(_show_popup_compare, this, show_popup_compare_fn).call(this);
      }
      getterRunFn(_action_after_remove_add, this, action_after_remove_add_fn).call(this, this.actionAfterAdded);
    })
    .catch(function (error) {
      console.log('Error: ' + error);
    })
    .finally(() => {
      this.setAttribute('aria-busy', false);
    });
  }
  else {
    // local wishlist
    // adds the specified elements to the beginning of an array
    this.array.unshift(getterGet(_wishlist_id, this));
    //console.log(this.array, getterGet(_wishlist_id, this))
    if (this.array.length > this.limit) {
      // if over limit remove element on last array
      let arraySplice = this.array.splice(this.limit, 1);
      // arraySplice: allway has 1 element
      $$4(`hdt-${this.textFn}[data-id="${arraySplice[0]}"]`).forEach(btn => {
        btn.setAttribute('action', 'add');
      });
    }
    if (!this.isFnWishlist) getterRunFn(_show_popup_compare, this, show_popup_compare_fn).call(this);
    getterRunFn(_action_after_remove_add, this, action_after_remove_add_fn).call(this, this.actionAfterAdded);
    localStorage.setItem(this.nameCached, this.array.toString());
  }
};
remove_wis_fn = function (e) {
  // REMOVE
  if ($wishlist_list && this.isFnWishlist || $compare_list && !this.isFnWishlist) {
    // app wishlist
    this.setAttribute('aria-busy', true);
    fetch(this.isFnWishlist ? linkWishlistApp : linkCompareApp, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        product_id: getterGet(_wishlist_id, this),
        product_handle: getterGet(_wishlist_handle, this),
        action: 'add',
        _method: 'DELETE'
      })
    })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      if (data.status != 'success') {
        console.error(data.message || 'Unknow error');
        return;
      }
      arr_wishlist_list = JSON.parse(data.response.metafield.value).ecomrise_ids;
      if (!Array.isArray(arr_wishlist_list)) {
        arr_wishlist_list = arr_wishlist_list.split(',');
      }
      getterRunFn(_action_after_remove_add, this, action_after_remove_add_fn).call(this, 'add');
    })
    .catch(function (error) {
      console.log('Error: ' + error);
    })
    .finally(() => {
      this.setAttribute('aria-busy', false);
    });
  } else {
    // local wishlist
    this.array.splice(this.array.indexOf(getterGet(_wishlist_id, this)), 1);
    localStorage.setItem(this.nameCached, this.array.toString());

    getterRunFn(_action_after_remove_add, this, action_after_remove_add_fn).call(this, 'add');
  }
};
action_after_remove_add_fn = function (action) {

  if (this.getAttribute('action') == 'remove' && this.hasAttribute('remove-on-page')) {
    if (this.isFnWishlist) {
      this.closest('.hdt-card-product').remove();
    } else {
      $$4(`.hdt-compare-item-${getterGet(_wishlist_id, this)}`).forEach(item => {
        item.remove();
      });
    }
    getterRunFn(_update_wis_btns, this, update_wis_btns_fn).call(this, action);
    if (this.array.length == 0) {
      $id4(`drawerCompare`)?.removeAttribute('open');
      if (this.isPageWishlistorCompare) window.location.href = getterRunFn(_conver_to_link, this, conver_to_link_fn).call(this);
    }
    //this.setAttribute('action', action);
  } else {
    getterRunFn(_update_wis_btns, this, update_wis_btns_fn).call(this, action);
    // is page wishlist or compare reload page
    if (this.isPageWishlistorCompare) window.location.href = getterRunFn(_conver_to_link, this, conver_to_link_fn).call(this);
  }
};
show_popup_compare_fn = function (event) {
  if (!themeHDN.extras.enableComparePopup || this.isPageWishlistorCompare) return;
  // add code if want show popup compare
  $$4('hdt-tooltip-dialog').forEach((tooltip)=> {
    tooltip.setAttribute('hidden', '');
  }); // Fix https://github.com/The4-Theme-Dev/Ecomus/issues/81
  $id4(`drawerCompare`).setAttribute('open', '');
  fetch(conver_to_link_fn('compare', arr_compare_list) + "&section_id=compare-offcanvas")
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const prds = html.querySelector('offcanvas-compare');

      if (prds && prds.innerHTML.trim().length) {

        $4("offcanvas-compare").innerHTML = prds.innerHTML;
      }
    })
    .catch((e) => {
      console.error(e);
    });
};
var _clear_all, clear_all_fn;
class ClearAll extends HTMLElement {
  constructor() {
    super();
    getterAdd(_clear_all, this);
    this.tabIndex = 0;
    this.addEventListener("click", getterRunFn(_clear_all, this, clear_all_fn));
    this.addEventListener("keydown", (event) => {
      if (event.key == "Enter") getterRunFn(_clear_all, this, clear_all_fn).call(this)
    });
  }
  get ofFn() {
    return this.getAttribute('of-fn'); //'compare', 'wishlist'
  }
  get nameCached() {
    return this.ofFn == 'compare' ? nameCachedCompare : nameCachedWishlist;
  }
  set array(value) {
    this.ofFn == 'compare' ? arr_compare_list = value : arr_wishlist_list = value;
  }
};
_clear_all = new WeakSet();
clear_all_fn = function () {
  localStorage.removeItem(this.nameCached);
  // Update Buttons
  $$4(`hdt-${this.ofFn}[action="added"]`).forEach(btn => {
    btn.setAttribute('action', 'add');
  });
  // Update Count and link
  document.dispatchEvent(new CustomEvent(`theme4:${this.ofFn}:update`, {
    bubbles: true,
    detail: 'the4'
  }));
  this.array = [];
  $id4(`drawerCompare`)?.removeAttribute('open');
  if ($4(`#drawerCompare offcanvas-compare`)){
    $4(`#drawerCompare offcanvas-compare`).innerHTML = "";
  }
};
customElements.define("hdt-clear-all", ClearAll);
// eg: <hdt-clear-all role="button" of-fn="compare">Clear All </hdt-clear-all>

// Update count
class WishlistCount extends HTMLElement {
  constructor() {
    super();
    this.textContent = this.array.length;
    document.addEventListener(`theme4:${this.prefix}:update`, (e) => {
      //console.log(this.prefix + ' count update.');
      this.textContent = this.array.length;
    });
  }
  get isFnWishlist() {
    return true;
  }
  get array() {
    return this.isFnWishlist ? arr_wishlist_list : arr_compare_list;
  }
  get prefix() {
    return this.isFnWishlist ? 'wishlist' : 'compare';
  }
}
// Update link page
class WishlistLink extends HTMLElement {
  constructor() {
    super();
    $4('a', this).href = conver_to_link_fn(this.prefix, this.array);
    //console.log('WishlistLink', this.href)
    document.addEventListener(`theme4:${this.prefix}:update`, (e) => {
      $4('a', this).href = conver_to_link_fn(this.prefix, this.array);
    });
  }
  get isFnWishlist() {
    return true;
  }
  get array() {
    return this.isFnWishlist ? arr_wishlist_list : arr_compare_list;
  }
  get prefix() {
    return this.isFnWishlist ? 'wishlist' : 'compare';
  }
}
customElements.define("hdt-wishlist", Wishlist);
customElements.define("hdt-wishlist-count", WishlistCount);
customElements.define("hdt-wishlist-a", WishlistLink);

// COMPARE
class Compare extends Wishlist {
  get isFnWishlist() {
    return false;
  }
  get textFn() {
    return 'compare';
  }
}
// Update count
class CompareCount extends WishlistCount {
  get isFnWishlist() {
    return false;
  }
}
// Update link page
class CompareLink extends WishlistLink {
  get isFnWishlist() {
    return false;
  }
}
customElements.define("hdt-compare", Compare);
customElements.define("hdt-compare-count", CompareCount);
customElements.define("hdt-compare-a", CompareLink);

// --------------------------
// Product Recommendations
// --------------------------
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          document.dispatchEvent(new CustomEvent("currency:update"));
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


// --------------------------
// Product Recently
// --------------------------
class ProductRecently extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      let handleProducts = localStorage.getItem("theme4:recently:id");
      let prdId = this.dataset.id;

      if (handleProducts !== null) {
        let products = handleProducts.split(',');
        let url = this.dataset.url.replace('q=', 'q=id:' + products.join("%20OR%20id:"));
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recently = html.querySelector('product-recently');

            if (recently && recently.innerHTML.trim().length) {
              this.innerHTML = recently.innerHTML;
            }
            document.dispatchEvent(new CustomEvent("currency:update"));
          })
          .catch((e) => {
            console.error(e);
          });

      }
      let arrayProducts = handleProducts !== null ? handleProducts.split(',') : new Array;
      if (!arrayProducts.includes(prdId + '')) {
        if (arrayProducts.length >= 10) {
          arrayProducts.pop();
        }
        function prepend(value, array) {
          var newArray = array.slice();
          newArray.unshift(value);
          return newArray;
        }
        arrayProducts = prepend(prdId, arrayProducts);
        arrayProducts = arrayProducts.toString();
        localStorage.setItem("theme4:recently:id", arrayProducts);
      }
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recently', ProductRecently);


// --------------------------
// Predictive Search
// --------------------------
class PredictiveSearch extends Drawer {
  constructor() {
    super();
    // console.log(!this.hasAttribute('enabled'))
    if (!this.hasAttribute('enabled')) return;
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-results-search]');
    this.input = this.querySelector('input[type="search"]');
    this.sectionIdResults = this.getAttribute('data-section-id-results') || 'hdt_predictive-search';
    this.allPredictiveSearchInstances = $$4('predictive-search');
    this.skeleton = this.querySelector('[data-skeleton-search]');
    this.noResults = this.querySelector('.hdt-cart-no-results');
    this.hideWrapper = this.querySelector('.hdt-cart-hide-has-results');
    this.showWrapper = this.querySelector('.hdt-cart-show-has-results');
    this.btn_viewall = this.querySelector('.hdt-view_all');
    this.href = this.btn_viewall?.getAttribute("href");
    this.isOpen = false;
    this.abortController2 = new AbortController();
    this.searchTerm = '';
    if (this.input) {
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    const formData = new FormData(this.input.form);
    this.params = "";
    for (const [key, value] of formData) {
      if (key === 'q') break;
      this.params += `${key}=${value}&`;
    }

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    //this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      // this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;
    this.btn_viewall?.setAttribute("href", this.href.replace(/\/search\?q=.*/g, "/search?q=" + this.searchTerm));

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();
    if (!currentSearchTerm.length) return;
    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.openSearch();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    // switch (event.code) {
    //   case 'ArrowUp':
    //     this.switchOption('up');
    //     break;
    //   case 'ArrowDown':
    //     this.switchOption('down');
    //     break;
    //   case 'Enter':
    //     this.selectOption();
    //     break;
    // }
  }

  // onKeydown(event) {
  //   // Prevent the cursor from moving in the input when using the up and down arrow keys
  //   if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
  //     event.preventDefault();
  //   }
  // }
  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${themeHDN.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${this.params}section_id=${this.sectionIdResults}`, {
      signal: this.abortController2.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-' + this.sectionIdResults).innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          this.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.hideWrapper.style.cssText = "display: none;";
    this.showWrapper.style.cssText = "display: block;";
    this.skeleton.classList.remove("hdt-hidden");

    this.setAttribute('loading', true);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.openSearch();
    document.dispatchEvent(new CustomEvent("currency:update"));
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
  }

  openSearch() {
    //this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.skeleton.classList.add("hdt-hidden");
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
      this.hideWrapper.style.cssText = "display: block;";
      this.showWrapper.style.cssText = "display: none;";
      this.predictiveSearchResults.innerHTML = "";
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    //this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('hdt-predictive-search', PredictiveSearch);
// bundle product

const bundleProduct = () => {
  if (window.innerWidth < 768) {
    return;
  }
  let arrBundle = $$4("[data-bundle-pin]");
  if (!arrBundle) {
    return;
  }
  arrBundle.forEach((el) => {
    if (!el.dataset.trigger) {
      return;
    } else {
      el.onmouseover = () => {
        $4(el.dataset.trigger).classList.add("is--hover");
        $4(el.dataset.trigger)
          .closest("[data-bundle-parent]")
          .classList.add("has--hover");
      };
      el.onmouseleave = () => {
        $4(el.dataset.trigger).classList.remove("is--hover");
        $4(el.dataset.trigger)
          .closest("[data-bundle-parent]")
          .classList.remove("has--hover");
      };
    }
  });
};
bundleProduct();

// --------------------------
// Back to top
// --------------------------
class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute('config'));
    if (window.innerWidth < 768 && this.config.hiddenMobile) return;
    this.debounce_timer = 0;
    this.debounce_timer2 = 0;
    this.circlechart = this.querySelector('.hdt-circle-css');
    this.addEventListener("click", this.goTop.bind(this));
    window.addEventListener("scroll", this.backToTop.bind(this));
  }
  goTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  backToTop() {
    let self = this;
    if (this.debounce_timer) { clearTimeout(this.debounce_timer); }
    this.debounce_timer = setTimeout(function () {
      if (window.scrollY > self.config.scrollTop) {
        self.classList.add('is--show');
      } else {
        self.classList.remove('is--show');
      }
    }, 40);

    if (!this.circlechart) return;

    if (this.debounce_timer2) { clearTimeout(this.debounce_timer2); }

    this.debounce_timer2 = setTimeout(function () {
      let scrollTop2 = window.scrollY,
        docHeight = document.body.offsetHeight,
        winHeight = window.innerHeight,
        scrollPercent = scrollTop2 / (docHeight - winHeight),
        degrees = scrollPercent * 360;
      self.circlechart.style.setProperty("--cricle-degrees", degrees + 'deg');
    }, 6);
  }
}

customElements.define('back-to-top', BackToTop);


// --------------------------
// numberRandom
// --------------------------
class numberRandom extends HTMLElement {
  constructor() {
    super();
    let config = JSON.parse(this.getAttribute("config"));
    this.min = config.min;
    this.max = config.max;
    this.interval = config.interval;
    this.number = Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
    this.ofset = ["1", "2", "4", "3", "6", "10", "-1", "-3", "-2", "-4", "-6"];
    this.prioritize = ["10", "20", "15"];
    this.h = "";
    this.e = "";
    this.M = "";
    this.liveViewInt();
    setInterval(this.liveViewInt.bind(this), this.interval);
  }

  liveViewInt() {
    if (this.h = Math.floor(Math.random() * this.ofset.length), this.e = this.ofset[this.h], this.number = parseInt(this.number) + parseInt(this.e), this.min >= this.number) {
      this.M = Math.floor(Math.random() * this.prioritize.length);
      var a = this.prioritize[this.M];
      this.number += a
    }
    if (this.number < this.min || this.number > this.max) {
      this.number = Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
    }
    this.innerHTML = parseInt(this.number);
  }
}

customElements.define('number-random', numberRandom);

// --------------------------
// Lookbook product carousel
// --------------------------

class LookbookProductCarousel extends HTMLElement {

  constructor() {
    super();
    if (window.innerWidth > 767) {
      return;
    }
    this.lookbookMobile();
  }
  lookbookMobile() {
    let self = this;
    const el = self.querySelector('[lookbook-product-wrap]');
    const controls = self.querySelector('[hdt-slider-controls]');
    const btn_close = self.querySelector('button.hdt-close');
    const isToolBar = document.querySelector('.hdt-toolbar-mobile');
    let toolBarH = 0;
    if (!el | !controls | !btn_close) return;
    if (isToolBar) {
      toolBarH += isToolBar.offsetHeight;
    }

    self.querySelector('[lookbook-product-wrap]').style.bottom = `${toolBarH / 10}rem`;
    controls.addEventListener('click', () => {
      el.classList.add('hdt-open');
    })
    btn_close.addEventListener('click', () => {
      el.classList.remove('hdt-open');
    })
  }
}
customElements.define('lookbook-product-carousel', LookbookProductCarousel);

/**
  * Cookies
  * https://help.shopify.com/en/manual/your-account/privacy/cookies
  * https://shopify.dev/themes/trust-security/cookie-banner#create-a-snippet-to-host-the-banner
  * https://help.shopify.com/en/manual/your-account/privacy/privacy-preferences-manager?shpxid=965d0d2a-08E2-4654-4A13-D3F38646AC5D
  * https://shopify.dev/api/consent-tracking
*/

function convertNameCookies(name) {
  return name.replace(/=/g,'_');
}
function setCookie(name,value,days,hours) {
  var expires = "";
  if (days || hours) {
    var date = new Date();
    date.setTime(date.getTime() + (days ? days*24*60*60*1000 : hours*60*60*1000));
    expires = "; expires=" + date.toString();
  }
  document.cookie = convertNameCookies(name) + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = convertNameCookies(name) + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function eraseCookie(name) {
  document.cookie = convertNameCookies(name)+'=; Max-Age=-99999999;';
}

class cookiesBar extends HTMLElement {
  constructor() {
    super();
    this.cookies = JSON.parse(this.getAttribute("configs"));
    this.cookies.cookiesName = "theme4:cookies";
    this.cookies.drawer = this.querySelector("#drawerCookies");
    this.isShowCookiesAll = (this.cookies.show == '1');
    this.acceptBtn = this.cookies.drawer.querySelector(".hdt-pp_cookies__accept-btn");
    this.declineBtn = this.cookies.drawer.querySelector(".hdt-pp_cookies__decline-btn");
    this.loadCookieBanner(this);
    let self = this;
    this.acceptBtn?.addEventListener("click", this.handleAccept.bind(this));
    this.declineBtn?.addEventListener("click", this.handleDecline.bind(this));
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        const cookiesSelect = event.target.classList.contains('sys-cookies');
        if (!cookiesSelect) return;
        self.showCookiesBanner();
      })
      document.addEventListener('shopify:section:deselect', (event) => {
        const cookiesSelect = event.target.classList.contains('sys-cookies');
        if (!cookiesSelect) return;
        self.hideCookiesBanner();
      })
    }
  }
  handleAccept() {
    if (this.isShowCookiesAll) {
      setCookie(this.cookies.cookiesName, 'accepted', parseInt(this.cookies.day_next));
    }
    window.Shopify.customerPrivacy.setTrackingConsent(true, this.hideCookiesBanner.bind(this));
  }

  handleDecline() {
    if (this.isShowCookiesAll) {
      setCookie(this.cookies.cookiesName, 'accepted', parseInt(this.cookies.day_next));
    }
    window.Shopify.customerPrivacy.setTrackingConsent(false, this.hideCookiesBanner.bind(this));
  }

  showCookiesBanner() {
    this.cookies.drawer.setAttribute('open', '');
    $4("html").classList.remove("no-scroll");
  }

  hideCookiesBanner() {
    this.cookies.drawer.removeAttribute('open');
  }

  initCookieBanner() {
    const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
    const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

    if ((!userCanBeTracked && userTrackingConsent === 'no_interaction') || this.isShowCookiesAll) {
      if (!Shopify.designMode) {
        this.showCookiesBanner();
      }
    }
  }

  loadCookieBanner() {

    let self = this;
    if (this.cookies.drawer.length == 0) return;
    this.cookies.day_next = this.cookies.day_next || 60;
    this.isShowCookiesAll = (this.cookies.show == '1');
    if (getCookie(this.cookies.cookiesName) == 'accepted' || this.cookies.drawer.getAttribute("open") !== null) return;

    window.Shopify.loadFeatures([
      {
        name: 'consent-tracking-api',
        version: '0.1',
      }
    ],
      function (error) {
        if (error) {
          throw error;
        }
        self.initCookieBanner();
      });
  }
}

customElements.define('sys-cookies', cookiesBar);

// --------------------------
// Newsletter
// --------------------------

class newsletterModal extends HTMLElement {
  constructor() {
    super();
    this.configs = JSON.parse(this.getAttribute('configs'));
    if ( !Shopify.designMode && getCookie("theme4:newsletter:"+this.configs.id) == 'shown' ) return;
    this.modal = this.querySelector("#modalNewsletter-"+this.configs.id);
    this.action_close = this.querySelector('[action-close]');
    this.time_delay     = this.configs.time_delay;
    this.day_next       = this.configs.day_next;
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        const newsletterSelect = event.target.classList.contains('sys-newsletter');
        if (!newsletterSelect) return;
        this.modal.setAttribute('open', '');
      })
      document.addEventListener('shopify:section:deselect', (event) => {
        const newsletterSelect = event.target.classList.contains('sys-newsletter');
        if (!newsletterSelect) return;
        this.modal.removeAttribute('open');
      })
    }
    else {
      const fnShow = this.showModal.bind(this);
      const fnShowScroll = this.showModalScroll.bind(this);
      if(this.configs.after === 'time'){
        let tm = setTimeout(fnShow,this.configs.time_delay * 1000);
        this.modal.addEventListener("dialog:afterClose", () => {
          clearTimeout(tm);
          this.hideModal(false, true);
        });
      }else{
        window.addEventListener("scroll",fnShowScroll);
        this.modal.addEventListener("dialog:afterClose", () => {
          window.removeEventListener("scroll", fnShowScroll);
          this.hideModal(false, true);
        });
      }
      this.actionClose();
    }
  }

  showModal() {
    this.modal.setAttribute('open', '');
  }
  showModalScroll(){
    if (window.scrollY > this.configs.scroll_delay) {
      this.modal.setAttribute('open', '');
    }
  }
  hideModal(pause, off) {
    if (pause) {

    }
    if (off) {

      setCookie("theme4:newsletter:"+this.configs.id, "shown", this.day_next);
    }
  }
  actionClose(){
    let self= this;
    if(self.action_close){
      self.action_close.addEventListener('click',function(){
        self.modal.removeAttribute('open', '');
        self.hideModal(false, true);
      })
    }
  }

}
customElements.define('sys-newsletter', newsletterModal);

// --------------------------
// Exit
// --------------------------

class exitModal extends HTMLElement {
  constructor() {
    super();
    this.configs = JSON.parse(this.getAttribute('configs'));
    if ( !Shopify.designMode && getCookie("theme4:exit:"+this.configs.id) == 'shown' ) return;
    this.modal = this.querySelector("#modalExit-"+this.configs.id);
    this.day_next     = this.configs.day_next;
    this.btn_copy = this.querySelector('button[is="discount_copy"]');
    this.discount = this.querySelector('[is="discount"]');
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        const exitSelect = event.target.classList.contains('sys-exit');
        if (!exitSelect) return;
        this.showModal();
      })
      document.addEventListener('shopify:section:deselect', (event) => {
        const exitSelect = event.target.classList.contains('sys-exit');
        if (!exitSelect) return;
        this.modal.removeAttribute('open');
      })
    }
    else {
      if(this.configs.after === 'move_cursor'){
        if(window.innerWidth > 1150){
          this.moveCursor();
        }else{
          this.scrollPage();;
        }
      }else if(this.configs.after === 'scroll'){
        this.scrollPage();
        console.log();
      }
      else{
        this.amountTime();
      }
    }
  }
  // Move cursor out screen
  moveCursor(){
    const fnShow = this.showModal.bind(this);
    document.querySelector("body").addEventListener("mouseleave", fnShow);
    this.modal.addEventListener("dialog:afterClose", () => {
      document.querySelector("body").removeEventListener("mouseleave", fnShow);
      this.hideModal(false, true);
    });
  }
  //  scroll page
  scrollPage(){
    const fnShow = this.showModal.bind(this);
    let docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight - 500;
    let scroll= ()=>{
      if (window.scrollY >= docHeight) {
        fnShow();
      }
    }
    window.addEventListener("scroll",scroll);
    this.modal.addEventListener("dialog:afterClose", () => {
      window.removeEventListener("scroll",scroll);
      this.hideModal(false, true);
    });
  }
  // countdown time to show exit popup
  amountTime(){
    const fnShow = this.showModal.bind(this);
    let tm = setTimeout(fnShow,this.configs.time_delay * 1000);
    this.modal.addEventListener("dialog:afterClose", () => {
      clearTimeout(tm);
      this.hideModal(false, true);
    });
  }
  showModal() {
    let self = this;
    this.modal.setAttribute('open', '');
    if(self.btn_copy && self.discount){
      self.btn_copy.addEventListener('click',function(){
        self.discount.select();
        self.discount.setSelectionRange(0, 99999);
        document.execCommand("copy");
        self.btn_copy.querySelector('.hdt-tooltip-text').innerText = `${themeHDN.extras.exit_popup.copied}: ${self.discount.value}`
      })
      self.btn_copy.addEventListener('mouseleave',function(){
        self.btn_copy.querySelector('.hdt-tooltip-text').innerText = themeHDN.extras.exit_popup.copy
      })
    }
  }
  hideModal(pause, off) {
    if (pause) {

    }
    if (off) {
      setCookie("theme4:exit:"+this.configs.id, "shown", this.day_next);
    }
  }
}
customElements.define('sys-exit', exitModal);

// --------------------------
// Countdown Cart
// --------------------------

class cartCountdown extends HTMLElement {
  constructor() {
    super();
    let settMinutes = 60 * this.getAttribute("time"), time = parseInt(sessionStorage.getItem('cartTime')), display = this.querySelector('#timer_count');
    this.config = JSON.parse(this.getAttribute("config"));
    var self = this;
    function startTimer(duration, display) {
      let timer = duration, minutes, seconds;
      let countdown = setInterval(function () {
          minutes = parseInt(timer / 60, 10)
          seconds = parseInt(timer % 60, 10);
          minutes = minutes < 10 ? minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;
          display.textContent = minutes + self.config.labelm + " : " + seconds + self.config.labels;
          let calc = 60 * parseInt(timer / 60, 10) + parseInt(timer % 60, 10);
          if (!Shopify.designMode) {
            sessionStorage.setItem('cartTime', calc);
          }
          if (--timer < 0) {
            window.clearInterval(countdown);
            display.textContent = 0 + self.config.labelm + " : " + 0 + self.config.labels;
            fetch(Shopify.routes.root+"cart/clear.js")
            .then((response) => response.text())
            .then((text) => {
              console.log("Clear cart")
              window.location.href = `${Shopify.routes.root}cart`;
            })
            .catch((e) => {
              console.error(e);
            });
          }
      }, 1000);
    };
    if (time > 0) {startTimer(time, display);}
    else {startTimer(settMinutes, display)}
  }
}
customElements.define('cart-countdown', cartCountdown);

// --------------------------
// Form status
// --------------------------


const contactForm = $$4('form[action^="/contact"]');
contactForm.forEach(function(form) {
  form.addEventListener("submit", function(event){
    sessionStorage.setItem("the4:recentform", this.getAttribute("id"));
  })
});
const goToForm = (id) => {
  const form = $4(`#${id}`);
  const formParent = form.closest("hdt-modal");
  const buttonForm = $4(`[aria-controls="${formParent.id}"]`);
  // console.log(buttonForm)
  if (buttonForm) {
    buttonForm.scrollIntoView({ behavior: 'smooth' });
  }
}
var recentform = sessionStorage.getItem("the4:recentform") || "";

if (location.href.indexOf('contact_posted=true') > 0 && recentform !== "" ) {
  document.dispatchEvent( new CustomEvent('the4:recentform', { detail: { recentform: recentform }, bubbles: true, cancelable: true }) );
  $id4(recentform)?.classList.add("on-live");
  if ($4('.form-status-mirror-'+ recentform)) {
    $4('.form-status-mirror-'+ recentform).style.cssText = "display: block;";
  }
  goToForm(recentform);
}

else if (location.href.indexOf('customer_posted=true') > 0 && recentform !== "" ) {
  document.addEventListener('the4:recentform', (event)=>{
    let modal_id = document.getElementById(event.detail.recentform).getAttribute('data-id') || document.getElementById(event.detail.recentform).getAttribute('id');
    document.getElementById(modal_id)?.setAttribute('open','')
  })
  document.dispatchEvent( new CustomEvent('the4:recentform', { detail: { recentform: recentform }, bubbles: true, cancelable: true }) );
  $id4(recentform)?.classList.add("on-live");
  goToForm(recentform);
}
else if (location.href.indexOf('contact_posted=true') > 0 && location.href.indexOf('#') > 0 ) {
  var recentform = location.href.split("#")[1];
  if ($id4(recentform).length > 0) {
    sessionStorage.setItem("the4:recentform", recentform);
    $id4(recentform).classList.add("on-live");
    if ($4('.form-status-mirror-'+ recentform)) {
      $4('.form-status-mirror-'+ recentform).style.cssText = "display: block;";
    }
    goToForm(recentform);
  }
}



// --------------------------
// Total sold flash
// --------------------------
class flashSold extends VariantChangeBase {
  constructor() {
    super();
    var self = this;
    this.time = this.getAttribute("time");
    this.config = JSON.parse(this.getAttribute("flash-sold"));
    this.mins = this.config.mins;
    this.maxs = this.config.maxs;
    this.mint = this.config.mint;
    this.maxt = this.config.maxt;
    this.dataID = this.config.id;
    this.getS = sessionStorage.getItem("soldS" + this.dataID) || this.getRandomInt(this.mins, this.maxs);
    this.getT = sessionStorage.getItem("soldT" + this.dataID) || this.getRandomInt(this.mint, this.maxt);
    this.numS = parseInt(this.getS);
    this.numT = parseInt(this.getT);
    this.intervalTime = parseInt(this.config.time);
    this.$sold = this.querySelector('[data-sold]');
    this.$hour = this.querySelector('[data-hour]');
    this.limitMinMax();
    this.updateSold(this.numS, this.numT);
    setInterval(function () {
      this.numS = this.numS + self.getRandomInt(1, 4);
      this.numT = this.numT + (Math.random() * (0.8 - 0.1) + 0.1).toFixed(1) * 1;
      self.limitMinMax();
      self.updateSold(self.numS, self.numT);
    }, this.intervalTime);
  }

  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  updateSold(num1, num2) {
    this.$sold.innerHTML = num1;
    this.$hour.innerHTML = Math.floor(this.numT);
    sessionStorage.setItem("soldS" + this.dataID, num1);
    sessionStorage.setItem("soldT" + this.dataID, num2);
  }
  limitMinMax() {
    if (this.numS > this.maxs) this.numS = self.getRandomInt(this.mins, this.maxs)
    if (this.numT > this.maxt) this.numT = self.getRandomInt(this.mins, this.maxt)
  }
  #preVariantId;
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      if(variant.available){
        this.closest(".hdt-product-info__item").style.display = "block"
      }
      else {
        this.closest(".hdt-product-info__item").style.display = "none"
      }
    }
  }
}
customElements.define('flash-sold', flashSold);

// --------------------------
// Multi brands
// --------------------------
var hdtNavLoading = true;
class multiBrands extends HTMLElement {
  constructor() {
    super();
    if($id4("hdt-nav-ul").classList.value.includes("hdt-nav-loading") < 0){
      return false;
    }
    this.item = $$4("[item-brand]", this);
    // this.section_id = this.getAttribute("s_id");
    // this.url = "";
    if(this.item.length) {
      for(var i=0; i < this.item.length; i++) {
        if (this.item[i].parentElement.classList.value.includes("is--active")) {
          this.url = this.item[i].getAttribute("href");
          const lazyMb = $4('hdt-lazy-submenu#sub-hdt-nav-mb');
          if (lazyMb) {
            lazyMb.addEventListener('lazyhtml:added', () => $4(`#hdt-nav-ul-mb summary[data-url="${this.url}"]`)?.parentElement.setAttribute("open",""));
          } else {
            $4(`#hdt-nav-ul-mb summary[data-url="${this.url}"]`)?.parentElement.setAttribute("open","");
          }
          // localStorage.setItem("the4:brand:url", this.url);
          break;
        }
      }
      // if(this.url === "") {
      //   this.url = localStorage.getItem("the4:brand:url") || Shopify.routes.root;
      //   for(var i=0; i < this.item.length; i++) {
      //     if (this.item[i].getAttribute("href") === this.url) {
      //       this.item[i].parentElement.classList.add("is--active");
      //       $4("#hdt-nav-ul-mb summary[data-url=\""+ this.url +"\"]").parentElement.setAttribute("open","");
      //       if (i > 0) {
      //         this._init();
      //       }
      //       break;
      //     }
      //   }
      // }
    }
  }
  // _init(){
  //   var nameStorage = "the4:brand:nav" + this.url.replace(/\//g,'-');
  //   if(!Shopify.designMode && sessionStorage.getItem(nameStorage) !== null){
  //     $id4("hdt-nav-ul").innerHTML = sessionStorage.getItem(nameStorage);
  //     $id4("hdt-nav-ul").classList.remove("hdt-nav-loading");
  //     return;
  //   }
  //   if (!hdtNavLoading) {
  //     return;
  //   }
  //   fetch(this.url + "?section_id=" + this.section_id)
  //     .then((response) => response.text())
  //     .then((text) => {
  //       const html = document.createElement('div');
  //       html.innerHTML = text;
  //       const nav = html.querySelector('#hdt-nav-ul');
  //       if (nav && nav.innerHTML.trim().length) {
  //         $id4("hdt-nav-ul").innerHTML = nav.innerHTML;
  //         $id4("hdt-nav-ul").classList.remove("hdt-nav-loading");
  //         sessionStorage.setItem(nameStorage, nav.innerHTML.trim().replace(/^\s+|\s+$|\n/gm,''));
  //       }
  //     })
  //     .catch((e) => {
  //       console.error(e);
  //     });
  //   hdtNavLoading = false;
  // }
}

customElements.define('multi-brands', multiBrands);

// --------------------------
// Footer Accordion
// --------------------------

class FooterAccordion extends HTMLElement{
  constructor(){
    super();
    this.id = this.getAttribute('id');
    this.heading = $4(`#Heading-${this.id}`,this);
    this.content = $4(`#Content-${this.id}`,this);
    this.config = JSON.parse(this.getAttribute('config'));
    this.flag = false;
    if(!this.config){
      this.config = {
        accordion: true
      }
    }
    // if(window.innerWidth > 767){
    //   return;
    // }
    if(this.config.accordionMobile){
      this.init();
      window.addEventListener('resize', () => {
        window.innerWidth > 767 ? this.removeAttribute('open') : this.flag ? " " : this.init();
      })
    }
  }
  static observedAttributes = ['open'];
  get open(){
    return this.hasAttribute('open');
  }
  attributeChangedCallback(name, oldValue, newValue) {
    this.open ? this.content.style.setProperty('height', `${this.content.scrollHeight}px`) : this.content.style.removeProperty('height');
  }
  init(){
    window.innerWidth < 768 ? this.handleHeadingClick() : this.removeAttribute('open');
  }
  handleHeadingClick(){
    this.flag = true;
    this.heading.addEventListener('click', () =>{
      if(window.innerWidth > 767) return;
      this.open ? this.removeAttribute('open') : this.setAttribute('open', '');
    })
  }
}
customElements.define('hdt-faccordion',FooterAccordion);

// --------------------------
// Delivery Time
// --------------------------
// https://unpkg.com/dayjs@1.11.10/dayjs.min.js
import dayjs from "@theme/dayjs";
dayjs.locale('en'); // use locale globally
class orderDelivery extends VariantChangeBase {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute('config'));
    this.offDays          = this.config.off_day.replace(/ /g,'').split(",");
    this.nowDay           = dayjs();
    var format_day       = this.config.format_day,
        time             = this.config.time.replace("24:00:00", "23:59:59"),
        arrDayWeek       = ["SUN","MON","TUE","WED","THU","FRI","SAT"],
        dateStart        = this.config.estimateStartDate || 0,
        dateEnd          = this.config.estimateEndDate || 0,
        excludeDays      = this.config.cut_day.replace(/ /g,'').split(","),
        startDay         = dayjs(),
        i                = 0,
        endDay           = dayjs(),
        j                = 0,
        nowTime          = this.nowDay.format('HHmmss'),
        timeint          = time.replace(/ /g,'').replace(/:/g,''),

        arrDay           = themeHDN.extras.order.dayNames.replace(/ /g,'').split(","),
        arrMth           = themeHDN.extras.order.monthNames.replace(/ /g,'').split(",");

    /**
     * Check Time, if nowTime >=  timeint +1 day
     */
    if (parseInt(nowTime) >= parseInt(timeint)) {
      this.nowDay   = this.nowDay.add(1, 'day');
      startDay = startDay.add(1, 'day');
      endDay   = endDay.add(1, 'day');
    }

    /**
     * Mode: 2 - Shipping + delivery
     * Mode: 1 - Only delivery
     */

    if ( this.config.mode == '2' ) {

      // START DATE
      // if ngay khach mua trung voi ngay loai tru tang 1 ngay
      while (excludeDays.indexOf( arrDayWeek[startDay.format('d')] ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/YYYY') ) > -1) {
        startDay = startDay.add(1, 'day');
      }
      while (i < dateStart) {
        i++;
        startDay = startDay.add(1, 'day');
        if (excludeDays.indexOf( arrDayWeek[startDay.format('d')] ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/YYYY') ) > -1) {
          i--;
        }
      }

      // END DATE
      // if ngay khach mua trung voi ngay loai tru tang 1 ngay
      while (excludeDays.indexOf( arrDayWeek[endDay.format('d')] ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/YYYY') ) > -1) {
        endDay = endDay.add(1, 'day');
      }

      while (j < dateEnd) {
        j++;
        endDay = endDay.add(1, 'day');
        if (excludeDays.indexOf( arrDayWeek[endDay.format('d')] ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/YYYY') ) > -1) {
          j--;
        }
      }

    }
    else {

      // START DATE
      startDay = startDay.add(dateStart, 'day');
      while (excludeDays.indexOf( arrDayWeek[startDay.format('d')] ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( startDay.format('DD/MM/YYYY') ) > -1) {
        startDay = startDay.add(1, 'day');
      }

      // END DATE
      endDay = endDay.add(dateEnd, 'day');
      while (excludeDays.indexOf( arrDayWeek[endDay.format('d')] ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/****') ) > -1 || this.offDays.indexOf( endDay.format('DD/MM/YYYY') ) > -1) {
        endDay = endDay.add(1, 'day');
      }
      // endDay = endDay.add(this.offDaysf(endDay), 'day');

    }

    /**
     * Translate day, month
     * https://day.js.org/docs/en/display/format
     */

    arrDay = this.ArrUnique(arrDay);
    arrMth = this.ArrUnique(arrMth);

    var startDayDInt = parseInt(startDay.format('D')),
    daystStart       = startDayDInt + this.nth(startDayDInt),
    MntStart         = arrMth[ parseInt(startDay.format('M')) -1 ],
    dayStart         = arrDay[ parseInt(startDay.format('d')) ],

    EndDayDInt       = parseInt(endDay.format('D')),
    daystEnd         = EndDayDInt + this.nth( EndDayDInt ),
    MntEnd           = arrMth[ parseInt(endDay.format('M')) -1 ],
    dayEnd           = arrDay[ parseInt(endDay.format('d')) ];

    //console.log( startDayDInt, EndDayDInt )
    if($4('[data-start-delivery]', this)) $4('[data-start-delivery]', this).innerHTML = startDay.format(format_day).replace('t44',dayStart).replace('t45',daystStart).replace('t46',MntStart);
    if($4('[data-end-delivery]', this)) $4('[data-end-delivery]', this).innerHTML = endDay.format(format_day).replace('t44',dayEnd).replace('t45',daystEnd).replace('t46',MntEnd);
  }

  ArrUnique(arr) {
    var onlyUnique = function (value, index, self) {
      return self.indexOf(value) === index;
    };
    return arr.filter( onlyUnique );
  }

  nth(d) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1:  return "st";
      case 2:  return "nd";
      case 3:  return "rd";
      default: return "th";
    }
  }
  #preVariantId;
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      if(variant.available){
        this.closest(".hdt-product-info__item").style.display = ""
        if( variant.variant_state.pre_order && this.config?.hideWithPreorder ) {
          this.closest(".hdt-product-info__item").style.display = "none"
        }
      }
      else {
        this.closest(".hdt-product-info__item").style.display = "none"
      }
    }
  }
}
customElements.define('order-delivery', orderDelivery);
class countdownSimple extends HTMLElement {
  x = 0;
  constructor() {
    super();

    /** Countdown
     * [days] [hours] [mins] [secs]
     */

    this.config = JSON.parse(this.getAttribute('config'));
    const time = this.config.time.replace("24:00:00", "23:59:59")

    if (time == '19041994') return;
    this.textTemp = $4("template", this).innerHTML;
    this.notHasDay  = !this.textTemp.includes('[days]');
    let today        = dayjs();

    const nowTime      = today.format('HHmmss'),
          configTime   = time.replace(/ /g,'').replace(/:/g,'')

    if (parseInt(nowTime) >= parseInt(configTime)) {
      today = today.add(1, 'day');
    }
    // Set the date we're counting down to
    // "2030-01-05 15:37:25"
    this.countDownDate = new Date(`${today.format('YYYY-MM-DD')} ${time}`).getTime();

    // Update the count down every 1 second
    this.#update();
    this.x = setInterval( this.#update.bind(this), this.textTemp.includes('[secs]') ? 1000 : 60000);
  }
  #update() {
    // Get today's date and time
    const now = new Date().getTime();

    // Find the distance between now and the count down date
    const distance = this.countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    const days    = Math.floor(distance / (1000 * 60 * 60 * 24));
    let   hours   = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    if (this.notHasDay) hours = days*24 + hours;

    // Display the result in the element
    this.innerHTML = this.textTemp.replace('[days]', String(days).padStart(2, '0')).replace('[hours]', String(hours).padStart(2, '0')).replace('[mins]', String(minutes).padStart(2, '0')).replace('[secs]', String(seconds).padStart(2, '0'));

    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(this.x);
      // EXPIRED
      this.hidden = true
    }
  }
  disconnectedCallback() {
    clearInterval(this.x);
  }
}
customElements.define('hdt-countdown-simple', countdownSimple);

class countdownTimer extends VariantChangeBase {
  constructor() {
    super();
  }
  #preVariantId;
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      if(variant.available){
        this.style.display = ""
      }
      else {
        this.style.display = "none"
      }
    }
  }
}
customElements.define('countdown-timer', countdownTimer);

// quick order list

var createCartPromise = ()=> {
  return new Promise(async (resolve) => {
    resolve(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
  });
};
var _upate_qty,
upate_qty_fn;
class QuickOrderList extends HTMLElement {
  constructor() {
    super();
    const ON_CHANGE_DEBOUNCE_TIMER = 300;
    this.actions = {
      add: 'ADD',
      update: 'UPDATE',
    };
    this.quickOrderListId = '#'+this.id;
    this.sectionId = this.dataset.sectionId;
    this.updateThink();

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    getterAdd(_upate_qty, this);
    document.addEventListener("cart:push:section.id", (event) => event.detail.sections.push(this.sectionId));
  }
  onSubmit(event) {
    event.preventDefault();
  }

  connectedCallback() {
    document.addEventListener($4('hdt-cart-drawer') ? 'cart:drawer:change' : 'variant:add', this.fetchQuickOrder.bind(this) );
  }
  //disconnectedCallback() {}

  updateThink() {
    this.items_in_cart = $4('[update_items_in_cart]', this);
    this.items_price_in_cart = $4('[update_items_price_in_cart]', this);
    $4('form#QuickOrderList', this).addEventListener('submit', this.onSubmit.bind(this));
  }
  fetchQuickOrder(event) {
    const html = new DOMParser().parseFromString(event.detail.sections[this.sectionId], 'text/html');
    const sourceQty = html.querySelector(this.quickOrderListId);
    $4('form#QuickOrderList', this).removeEventListener('submit', this.onSubmit.bind(this));
    this.innerHTML = sourceQty.innerHTML;
    document.dispatchEvent(new CustomEvent("currency:update"));
    this.updateThink();
    // fetch(`${window.location.pathname}?section_id=${this.sectionId}`)
    //   .then((response) => response.text())
    //   .then((responseText) => {
    //     const html = new DOMParser().parseFromString(responseText, 'text/html');
    //     const sourceQty = html.querySelector(this.quickOrderListId);
    //     this.innerHTML = sourceQty.innerHTML;
    //   })
    //   .catch((e) => { console.error(e); });
  }
  onChange(event) {
    const inputValue = parseInt(event.target.value);
    const cartQuantity = parseInt(event.target.dataset.cartQuantity);
    const index = event.target.dataset.index;
    const quantity = inputValue - cartQuantity;

    if (cartQuantity > 0) {
      this.updateQuantity(index, inputValue, this.actions.update);
    } else {
      this.updateQuantity(index, quantity, this.actions.add);
    }
  }
  onLoading(id){
    $4(`#Variant-${id} [price_loading]`, this)?.setAttribute('aria-busy',true);
    $$4('#hdt-quick-order-list-total .hdt-btn-loading__svg', this).forEach(el => el.setAttribute('aria-busy',true));
  }
  deLoading(id){
    $4(`#Variant-${id} [price_loading]`, this)?.setAttribute('aria-busy',false);
    $$4('#hdt-quick-order-list-total .hdt-btn-loading__svg', this).forEach(el => el.setAttribute('aria-busy',false));
  }
  removeButton(id,quantity){
    quantity !== 0 ? $4(`#Variant-${id} hdt-quick-order-list-remove-button`, this).removeAttribute('hidden') : $4(`#Variant-${id} hdt-quick-order-list-remove-button`, this).setAttribute('hidden','');
  }
  updateInCart(id,variant_in_cart){
    //  label
    $4(`#Variant-${id} .hdt-quantity__rules-cart`, this).removeAttribute('hidden');
    let variant_qty_cart = $4(`#Variant-${id} .hdt-quantity-cart`, this);

    //  totals
    let variant_total = $4(`#Variant-${id} [variant_update_price]`, this);

    // update
    if(variant_in_cart?.length !== 0 && variant_in_cart){
      let variant_total_price = parseFloat(variant_in_cart.original_line_price)
      variant_qty_cart.innerText = variant_in_cart.quantity
      variant_total.innerText = formatMoney(variant_total_price,themeHDN.settings.currencyFormat);
      variant_total.setAttribute('data-variant-price', variant_total_price);
    } else {
      variant_qty_cart.innerText = 0;
      variant_total.innerText = formatMoney(0,themeHDN.settings.currencyFormat);
      variant_total.setAttribute('data-variant-price', 0);
      $4(`#Variant-${id} .hdt-quantity__rules-cart`, this).setAttribute('hidden','');
    }
    this.removeT4CrurrencyData(variant_total);
  }
  removeT4CrurrencyData(el, dataset = el.dataset) {
    for (const [key, value] of Object.entries(dataset)) {
      if(key.toLowerCase().indexOf("currency") >= 0) delete el.dataset[key];
    }
  }
  updateTotalInCart(){
    let items_total = 0;
    let items_price = 0;

    // update items_total
    let items = $$4('[data-cart-quantity]', this);
    items.forEach(item => {
      return items_total += parseInt(item.getAttribute('data-cart-quantity'));
    })
    this.items_in_cart.innerText = items_total;

    // update items_price
    let prices = $$4('[data-variant-price]', this);
    prices.forEach(price =>{
      return items_price += parseFloat(price.getAttribute('data-variant-price'));
    })
    this.items_price_in_cart.innerText = formatMoney(items_price,themeHDN.settings.currencyFormat);
    this.removeT4CrurrencyData(this.items_price_in_cart);
    document.dispatchEvent(new CustomEvent("currency:update"));
  }

  fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }
  // update quantity product
  updateQuantity(id, quantity, action) {
    document.dispatchEvent(new CustomEvent("theme:loading:doing",{bubbles:!0}));
    this.removeButton(id,quantity);
    this.onLoading(id);
    let bundleSections = [];
    document.dispatchEvent(new CustomEvent("cart:push:section.id", { bubbles: true, detail: { sections: bundleSections } }));
    let routeUrl = `${Shopify.routes.root}cart/change.js`;
    let body = JSON.stringify({
      quantity,
      id,
      sections_url: window.location.pathname,
      sections: bundleSections.join(",")
    });
    let fetchConfigType;

    if (action === this.actions.add) {
      fetchConfigType = 'javascript';
      routeUrl = `${Shopify.routes.root}cart/add.js`;
      body = JSON.stringify({
        items: [
          {
            quantity: parseInt(quantity),
            id: parseInt(id),
          },
        ],
        sections_url: window.location.pathname,
        sections: bundleSections.join(",")
      });
    }

    fetch(`${routeUrl}`, { ...this.fetchConfig(fetchConfigType), ...{ body } })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      let cartContent = JSON.parse(state);
      const quantityElement = document.getElementById(`Quantity-${id}`);

      if(quantity === 0){
        this.resetQuantityInput(id,quantityElement,true);
      }
      quantityElement.setAttribute('data-cart-quantity',quantity);
      getterRunFn(_upate_qty, this, upate_qty_fn).call(this, cartContent, parseInt(id), action, bundleSections)
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      this.updateTotalInCart();
      document.dispatchEvent(new CustomEvent("currency:update"));
      document.dispatchEvent(new CustomEvent("theme:loading:done",{bubbles:!0}));
      this.deLoading(id);
    });
  }
  resetQuantityInput(id, quantityElement,resetValue) {
    const input = quantityElement ?? document.getElementById(`Quantity-${id}`);
    input.value = input.getAttribute('value');
    resetValue ? input.value = 0 : input.value = input.getAttribute('value');
  }
  updateError(updatedValue, id) {
    let message = '';
    if (typeof updatedValue === 'undefined') {
      message = window.cartStrings.error;
    } else {
      message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
    }
    this.updateLiveRegions(id, message);
  }

  updateLiveRegions(id, message) {
    const variantItemError = this.getElementById('Quick-order-list-item-error');
    if (variantItemError) {
      $4('.hdt-variant-item__error-text', variantItemError).innerHTML = message;
      variantItemError.removeAttribute('hidden');
    }
  }

}
_upate_qty = new WeakSet();
upate_qty_fn = async function(cartContent, id, action) {
  const variant_in_cart = cartContent.items.find((item) => item.variant_id === id);
  this.updateInCart(id,variant_in_cart);
  this.dispatchEvent(new CustomEvent("quickOrder:change", { bubbles: false}));
  //document.dispatchEvent(new CustomEvent("cart:refresh"));
  let cart = cartContent;
  if (action === this.actions.add) {
    cart = await createCartPromise();
    cart.sections = cartContent.sections;
  }
  document.dispatchEvent(new CustomEvent("cart:change", {
    bubbles: true,
    detail: {
      baseEvent: "line-item:change",
      cart,
      disabledDrawerChange: true
    }
  }));
};

customElements.define('hdt-quick-order-list', QuickOrderList);

// remove variant in cart
class QuickOrderListRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click',(event) => {
      event.preventDefault();
      const quickOrderList = this.closest('hdt-quick-order-list');
      quickOrderList.updateQuantity(this.dataset.index, 0);
      this.setAttribute('hidden','');
    });
  }
}

customElements.define('hdt-quick-order-list-remove-button', QuickOrderListRemoveButton);

// remove all variant in cart
class QuickOrderListRemoveAllButton extends HTMLElement {
  constructor() {
    super();
    this.quickOrderList = this.closest('hdt-quick-order-list');
    const allVariants = Array.from(this.quickOrderList.querySelectorAll('[data-variant-id]'));
    const items = {};
    const list_variants = []
    let hasVariantsInCart = false;

    allVariants.forEach((variant) => {
      const cartQty = parseInt(variant.dataset.cartQty);
      if (cartQty > 0) {
        hasVariantsInCart = true;
        items[parseInt(variant.dataset.variantId)] = 0;
        list_variants.push(variant.dataset.variantId);
      }
    });

    if (!hasVariantsInCart) {
      this.setAttribute('hidden','')
    }

    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.quickOrderList.updateMultipleQty(items,list_variants);
      this.setAttribute('hidden','')
    });
  }
}

customElements.define('hdt-quick-order-list-remove-all-button', QuickOrderListRemoveAllButton);


// Begin instagram feed api
const dataInstagramCache = {};
class instagramFeedAPI extends HTMLElement {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute('config'));
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        this.refresh_ins();
      })
      document.addEventListener('shopify:section:deselect', (event) => {
        const {acc,id} = this.config;
        var data = sessionStorage.getItem('hdt_ins'+acc+id);
        if (data != null && data != '') {
          sessionStorage.removeItem('hdt_ins'+acc+id);
        }
      })
    }
  }
  connectedCallback() {
    this.refresh_ins();
  }
  refresh_ins(){
    const {acc,id} = this.config;

    if (acc == '') return;

    var data = sessionStorage.getItem('hdt_ins'+acc+id);

    if (data != null && data != '') {
      // calculate expiration time for content,
      // to force periodic refresh after 30 minutes
      var now = new Date(),
      expiration = new Date(JSON.parse(data).timestamp);

      expiration.setMinutes(expiration.getMinutes() + 30);

      // ditch the content if too old
      if (now.getTime() > expiration.getTime()) {
        data = null;
        sessionStorage.removeItem('hdt_ins'+acc+id);
      }
    }
    if ( data != null && data != '' ) {
      this.instagramHTML(JSON.parse(data).content,false);
    }
    else{
      if (dataInstagramCache[acc]) {
        $4('.hdt-slider__container', this).innerHTML = dataInstagramCache[acc];
        $4('.hdt-ins-loading', this)?.remove();
        const lazySlider = $4('hdt-slider-lazy', this);
        if (lazySlider) {
          lazySlider.hidden = false;
          lazySlider.InitLazy();
        }
        return;
      }

      fetch('https://graph.instagram.com/me/media?fields=id,media_type,media_url,permalink,thumbnail_url,caption,children&access_token='+atob(acc))
      .then((response) => {
        if(!response.ok) { throw new Error("not ok"); }
        return response.json()
      })
      //.then(function(res)
      .then((res) => {
        //console.log('Success:', res);
         this.instagramHTML(res.data,true);
      })
      .catch(() => {
        $4('.hdt-ins-loading', this)?.remove();
        console.error("Instagram Feed:error fetch");
      });
    }
  }
  instagramHTML(data,saveSessionStorageIns) {
    const arrIcons = ($4('.hdt-icons-ins-svg', this).innerHTML || '').split('[hdtplit]'),
    icons = {
       image : arrIcons[0],
       video : arrIcons[1],
       carousel_album: arrIcons[2]
    },
    {id, acc, target, limit} = this.config;
    let html = '';

    data.forEach( (el, index) => {
      if (index >= limit) return 0;
      const media_type = el.media_type.toLowerCase();
      html += `<div class="hdt-slider__slide hdt-ins-type-${media_type}"><a calc-nav data-no-instant rel="nofollow" class="hdt-ins-inner hdt-block hdt-relative hdt-oh hdt-radius" href="${el.permalink}" target="${target}"><div class="hdt-ratio"><img src="${el.thumbnail_url || el.media_url}" class="hdt-ins-img" loading="lazy"></div><div class="hdt-ins-icon">${icons[media_type]}</div></a></div>`
    });
    dataInstagramCache[acc] = html;
    $4('.hdt-slider__container', this).innerHTML = html;
    $4('.hdt-ins-loading', this)?.remove();
    const lazySlider = $4('hdt-slider-lazy', this);
    if (lazySlider) {
      lazySlider.hidden = false;
      lazySlider.InitLazy();
    }

    if(saveSessionStorageIns){
      sessionStorage.setItem('hdt_ins'+acc+id, JSON.stringify({
        timestamp: new Date(),
        content: data
      }));
    }
  }
}
customElements.define('ins-feed-api', instagramFeedAPI);

// End instagram feed api

// Tab main-brands //
class TabsBrands extends HTMLElement {
  constructor() {
    super();
    this.links = this.querySelectorAll('.hdt-tab-link');
    this.tabs = this.querySelectorAll('.hdt-tab-content');
    this.addAllListeners();
  }

  addAllListeners() {
    this.links.forEach(link => {
      link.addEventListener('click', () => {
        const tabName = link.getAttribute('data-filter');
        if (tabName === 'all') {
          this.openAllTabs();
        } else {
          this.openTab(tabName);
        }
        this.links.forEach(item => {
          item.classList.remove('is--active');
        });
        if (!link.classList.contains('is--active')) {
          link.classList.add('is--active');
        }
      });
    });
  }

  openAllTabs() {
    this.tabs.forEach(content => {
      content.style.display = 'block';
      content.style.height = 'auto';
    });
    this.querySelector('[data-filter="all"]').classList.add('is--active');
  }

  openTab(tabName) {
    this.tabs.forEach(content => {
      if (content.id === tabName) {
        content.style.display = 'block';
        content.classList.add('slideInRight');
      } else {
        content.style.display = 'none';
        content.classList.remove('slideInRight');
      }
    });
  }

  connectedCallback() {
    this.addAllListeners();
  }
  disconnectedCallback() {
  }
}

customElements.define('tabs-brands', TabsBrands);

//  //


class countryFilter extends HTMLElement {
  constructor() {
    super();
    this.search = $4('[name=country_filter]', this);
    this.reset = $4(".hdt-country_filter__reset", this);
    if (this.search) {
      this.search.addEventListener(
        'input',
        debounce((event) => {
          this.filterCountries();
        }, 200).bind(this)
      );
    }
    this.search.addEventListener('keydown', this.onSearchKeyDown.bind(this));

  }
  filterCountries(){
    const searchValue = this.search.value.toLowerCase();
    const allCountries = this.closest("hdt-popover").querySelectorAll('hdt-richlist button');
    let visibleCountries = allCountries.length;
    allCountries.forEach((item) => {
      const countryName = item.getAttribute('data-name').toLowerCase();
      if (countryName.indexOf(searchValue) > -1) {
        item.classList.remove('hdt-d-none');
        visibleCountries++;
      } else {
        item.classList.add('hdt-d-none');
        visibleCountries--;
      }
    });
    this.closest("hdt-popover").updatePos();
    this.closest("hdt-popover").shadowRoot.querySelector('.hdt-current-scrollbar').scrollTop = 0;
  }

  onSearchKeyDown(event) {
    if (event.code.toUpperCase() === 'ENTER') {
      event.preventDefault();
    }
  }
}

customElements.define('country-filter', countryFilter);


// check purchase code
if(Shopify.designMode){

  /**
  * If it's a global variable then window[variableName] or in your case window["onlyVideo"] should do the trick.
  * https://stackoverflow.com/questions/5613834/convert-string-to-variable-name-in-javascript
  */
  function isStorageSupported(type) {
    // Return false if we are in an iframe without access to sessionStorage
    // window.self !== window.top

    var storage = (type === 'session') ? window.sessionStorage : window.localStorage;

    try {
      storage.setItem('t4s', 'test');
      storage.removeItem('t4s');
      return true;
    } catch (error) {
      return false;
    }
  };

  var ThemeCode    = atob(window[atob('Y0hWeVkyaGg=')]),
      ThemeName_base64 = window[atob('VkdobGJXVk9ZVzFsVkRR')],
      ThemeName            = atob(ThemeName_base64),
      CookieName           = 'SXNBY3RpdmVUaGVtZQ=='+ThemeName_base64,
      ShopEmail            = atob(window[atob('VTJodmNFMWxiMVEw')]),
      isTrueSet            = (sessionStorage.getItem(CookieName) === 'true' ),
      str_temp_active      = atob('I3Q0cy10ZW1wLWtleS1hY3RpdmU='), // #t4s-temp-key-active
      str_purchase         = atob('cHVyY2hhc2VfY29kZXQ0'); // purchase_codet4;

      // console.log(ThemeCode,ThemeName,ShopEmail,CookieName,str_temp_active,str_purchase)
  function alert_active_html() {
    return `<section id="${str_purchase}" style="display: flex !important">${ $4(str_temp_active).innerHTML }</section>`;
  };

  // console.log('ThemeCode', ThemeCode, isTrueSet)

  if (ThemeCode == '') {
    let dom1 = (new DOMParser).parseFromString(alert_active_html(), "text/html");
    document.body.append(dom1.body.firstElementChild);
    let dom2 = (new DOMParser).parseFromString('<div id="luffyabc194"><style>body>*:not(#purchase_codet4) {opacity: 0;pointer-events: none;</style></div>', "text/html");
    document.body.prepend(dom2.body.firstElementChild);
    sessionStorage.removeItem(CookieName);
    localStorage.removeItem(CookieName);
  }
  else if ( !isTrueSet ) {

    //console.log(ShopEmail, ThemeName, ThemeCode);

    var domain     = window.location.hostname,
    mix        = ['4','t','h','e','p','l','i','c','o','/','.',':','n','s'],
    mix_domain = mix[2]+mix[1]+mix[1]+mix[4]+mix[13]+mix[11]+mix[9]+mix[9]+mix[5]+mix[6]+mix[7]+mix[10]+mix[1]+mix[2]+mix[3]+mix[0]+mix[10]+mix[7]+mix[8]+mix[9]+mix[5]+mix[6]+mix[7]+mix[3]+mix[12]+mix[13]+mix[3]+mix[9]+mix[7]+mix[2]+mix[3]+mix[7]+'k',
    data       = {
      "shopify_domain": domain,
      "email"         : ShopEmail,
      "theme"         : ThemeName,
      "purchase_code" : ThemeCode
    };

    fetch(mix_domain, {
      "headers": {
        "accept": "*/*",
        "cache-control": "no-cache",
        "x-requested-with": "XMLHttpRequest"
      },
      "body": btoa (encodeURIComponent(JSON.stringify(data))) ,
      "method": "POST",
      "mode": "cors"
    })
    .then(function(response) {
      if(response.ok){
        return response.json()
      } throw ""
    })
    .then(function(response) {
      let dom = (new DOMParser).parseFromString(alert_active_html(), "text/html");

      if ( response.status == 1) {

        dom.body.firstElementChild.innerHTML = "<p>ACTIVATED SUCCESSFULLY. Thanks for buying my theme!</p>";
        document.body.append(dom.body.firstElementChild);

        // Set a cookie to expire in 1 hour in Javascript
        var isActived = localStorage.getItem(CookieName);
        sessionStorage.setItem(CookieName, 'true')

        if (isActived === 'true') {
          $4(atob('I3B1cmNoYXNlX2NvZGV0NA==')).remove(); // #purchase_codet4
          // $4(atob('I2x1ZmZ5YWJjMTk0'))?.remove(); //#luffyabc194
        }
        else {
          localStorage.setItem(CookieName, "true");
          setTimeout(function(){
            $4(atob('I3B1cmNoYXNlX2NvZGV0NA==')).remove(); // #purchase_codet4
            // $4(atob('I2x1ZmZ5YWJjMTk0'))?.remove(); //#luffyabc194
          }, 1000);
        }

      }
      else {

        var mess = response.message;
        if (mess == "No sale belonging to the current user found with that code") {

          dom.body.firstElementChild.innerHTML = "<p>Purchase code error. It is a sales reversal or a refund. :(((</p>";

        }
        else if (mess.length == 58 || mess.length == 101) {
          dom.body.firstElementChild.innerHTML = "<p>That license key doesn't appear to be valid. Please check your purchase code again!<br>Please open a ticket at <a href='https://support.the4.co' target='_blank'><span>support.the4.co</span></a> if you have any question.</p>";

        }
        else if (mess.length == 104) {
          dom.body.firstElementChild.innerHTML = "<p>The license not match with current theme.!<br>Please open a ticket at <a href='https://support.the4.co' target='_blank'><span>support.the4.co</span></a> if you have any question.</p>";
        }
        else {
          try {
            var mess = mess.split('active domain `')[1].split('`. ')[0];
          }
          catch(err) {
            //var mess = mess;
          }
          dom.body.firstElementChild.innerHTML = "<p>Your purchase code is invalided since it is being activated at another store "+mess+".<br> Please open a ticket at <a class='cg' href='https://support.the4.co' target='_blank'><span>support.the4.co</span></a> to get quick assistance.</p>";
        }
        document.body.append(dom.body.firstElementChild);

      }

    }).catch(function(e) {
    //}).catch((e)=>{
      console.error(e)
    });

  }
}
// end check purchase code

// readmore collection description
class DescriptionShort extends HTMLElement{
  constructor(){
    super();
    this.button_readmore = $4('[data-read-more]', this);
    this.button_readless = $4('[data-read-less]', this);
    this.short_des = $4('.hdt-collection-description-short', this);
    this.full_des = $4('.hdt-collection-description-full', this);
    if(!this.button_readmore || !this.button_readless || !this.short_des || !this.full_des){
      return;
    }
    this.button_readmore.addEventListener('click',(e)=>{
      // console.log(this);
      e.preventDefault();
      this.short_des.classList.add('hdt-hidden');
      this.full_des.classList.remove('hdt-hidden');
    })
    this.button_readless.addEventListener('click',(e)=>{
      // console.log(this);
      e.preventDefault();
      this.short_des.classList.remove('hdt-hidden');
      this.full_des.classList.add('hdt-hidden');
    })
  }
}
customElements.define('description-short',DescriptionShort)

// product description - readmore
class ProductDescription extends HTMLElement{
  constructor(){
    super();
  }
  connectedCallback(){
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.init();
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 0px 0px' }).observe(this);
  }
  init(){
    
    this.lm_btn = this.querySelector('[data-button]');
    this.content = this.querySelector('[data-content]');
    this.m_h = parseInt(this.dataset.heightLimit);
    if(!this.lm_btn || !this.content || !this.m_h) return;
    
    let content_h = this.content.scrollHeight;
    // console.dir(this.content);
    if(this.m_h > content_h){
      this.lm_btn.style.setProperty('display', 'none');
      return;
    }

    this.content.style.setProperty('--height', `${content_h}px`);
    this.content.style.setProperty('max-height', `${this.m_h}px`);
    this.content.style.setProperty('--max-height', `${this.m_h}px`);

    this.lm_btn.addEventListener('click',()=>{
      this.classList.toggle('is--less');
    })
  }
}
customElements.define('product-description',ProductDescription);


// ===========================
//        QUICK SEARCH
// ===========================
class QuickSearch extends HTMLElement{
  constructor(){
    super();
    this.inpt = this.closest('hdt-predictive-search').querySelector('form input[data-input-search]');
    this.query = this.querySelector('a');
    if(!this.inpt || !this.query) return;
    this.onClick();
  }
  onClick(){
    let self = this;
    this.query.addEventListener('click',(e) => {
      e.preventDefault();
      self.inpt.value = e.target.dataset.query;
      self.inpt.dispatchEvent(new Event('input'));
    })
  }
}
customElements.define('hdt-quick-search', QuickSearch);


// tabHover
class tabHover extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("mouseenter", (event) => {
      this.closest("hdt-tab").querySelector("button[aria-current=\"true\"]")?.setAttribute("aria-current", false);
      this.parentElement.click()
    });
  }
}
customElements.define("tab-hover", tabHover);


// footer accodion
function handleAccordionClick() {
  let accordion = this.parentElement;
  accordion.classList.toggle('open');
  if (window.innerWidth < 768) {
    let content = accordion.querySelector('.hdt-collapse-content');
    if(!content) return;
    if (accordion.classList.contains('open')) {
      content.style.height = content.scrollHeight + 'px';
    } else {
      content.style.height = '0';
    }
  }
}
function updateMaxHeight() {
  if (window.innerWidth >= 768) {
    document.querySelectorAll('.hdt-footer-section .hdt-collapse-content').forEach(function(content) {
      content.style.height = '';
    });
  }
}
document.querySelectorAll('.hdt-footer-section .hdt-heading-f').forEach(function(element) {
  element.addEventListener('click', handleAccordionClick);
});
window.addEventListener('resize', function() {
  if (window.innerWidth < 768) {
    document.querySelectorAll('.hdt-footer-section .hdt-heading-f').forEach(function(element) {
      element.removeEventListener('click', handleAccordionClick);
      element.addEventListener('click', handleAccordionClick);
    });
  } else {
    document.querySelectorAll('.hdt-footer-section .hdt-heading-f').forEach(function(element) {
      element.removeEventListener('click', handleAccordionClick);
    });
    updateMaxHeight();
  }
});


// video popup
class popupVideo extends HTMLElement {
  constructor(){
    super();
    this.modal = $4("hdt-modal", this);
    this.video = $4("hdt-video-player", this);
    this.modal.addEventListener("dialog:afterOpen", (e)=>{
      this.video.play()
    })
    this.modal.addEventListener("dialog:beforeClose", (e)=>{
      this.video.pause()
    })
  }
}
customElements.define('hdt-btn-popup-video', popupVideo);

// Mr Linh custom =========================

// Cart count with rezo
class HdtCartCountObserver {
  constructor(el) {
    this.el = el;
    this._active = false;
    this.mutationObserver = null;
    this.intersectionObserver = null;
    this._onIntersect = this._onIntersect.bind(this);
    this.isInCustomizer = window.Shopify && window.Shopify.designMode;
    this._init();
  }

  _init() {
    if (this.isInCustomizer) {
      this._startObserve();
      this._formatNumber();
    } else {
      this.intersectionObserver = new IntersectionObserver(this._onIntersect, { threshold: 0 });
      this.intersectionObserver.observe(this.el);
    }
  }

  _onIntersect(entries) {
    const entry = entries[0];
    if (entry.isIntersecting) {
      this._startObserve();
      this._formatNumber();
    } else {
      this._stopObserve();
    }
  }

  _startObserve() {
    if (this._active) return;
    this._active = true;
    this.mutationObserver = new MutationObserver(() => this._formatNumber());
    this.mutationObserver.observe(this.el, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  _stopObserve() {
    this._active = false;
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
      this.mutationObserver = null;
    }
  }

  _formatNumber() {
    let numText = this.el.textContent.trim();
    let num = parseInt(numText, 10);
    let newText = '';
    if (!isNaN(num)) {
      if (num >= 0 && num <= 9) {
        newText = '0' + num;
      } else {
        newText = String(num);
      }
      if (numText !== newText) {
        if (this.mutationObserver) this.mutationObserver.disconnect();
        this.el.textContent = newText;
        if (this.mutationObserver) {
          this.mutationObserver.observe(this.el, {
            childList: true,
            characterData: true,
            subtree: true
          });
        }
      }
    }
  }

  disconnect() {
    this._stopObserve();
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
  }
}

function applyCartCountObserver() {
  document.querySelectorAll('hdt-cart-count').forEach(el => {
    if (!el.__hdtCartCountObserver) {
      el.__hdtCartCountObserver = new HdtCartCountObserver(el);
    }
  });
}
applyCartCountObserver();

const cartCountMutationObserver = new MutationObserver(mutations => {
  for (let m of mutations) {
    m.addedNodes.forEach(node => {
      if (node.nodeType === 1 && node.tagName === 'HDT-CART-COUNT') {
        if (!node.__hdtCartCountObserver) {
          node.__hdtCartCountObserver = new HdtCartCountObserver(node);
        }
      }
      if (node.nodeType === 1) {
        node.querySelectorAll && node.querySelectorAll('hdt-cart-count').forEach(el => {
          if (!el.__hdtCartCountObserver) {
            el.__hdtCartCountObserver = new HdtCartCountObserver(el);
          }
        });
      }
    });
  }
});
cartCountMutationObserver.observe(document.body, { childList: true, subtree: true });

document.addEventListener('shopify:section:unload', function(e) {
  const section = e.target;
  section.querySelectorAll && section.querySelectorAll('hdt-cart-count').forEach(el => {
    if (el.__hdtCartCountObserver) {
      el.__hdtCartCountObserver.disconnect();
      el.__hdtCartCountObserver = null;
    }
  });
});

// Card counter
class HdtCardCounter extends HTMLElement {
  constructor() {
    super();
    this.targetNumber = Number(this.getAttribute("data-number")) || 0;
    this.preNum = 0;
    this.maxUpdates = 25;
    this.stepAniDuration = 0.2;
    this.duration = Math.min(this.maxUpdates * this.stepAniDuration, 2);
  }

  connectedCallback() {
    this.isCountdown = this.getAttribute("data-is-countdown") === "true";
    this.preNum = this.isCountdown ? this.targetNumber : 0;
    this.dataset.preNumber = Math.round(this.preNum);

    inView(this, () => {
      this.innerHTML = `<span class="hdt-counter-num hdt-current-num">${this.preNum.toLocaleString()}</span>`;

      let updateSteps = [];
      if (this.targetNumber < this.maxUpdates) {
        for (let i = 1; i <= this.targetNumber; ++i) updateSteps.push(i);
      } else {
        for (let i = 1; i <= this.maxUpdates; ++i) {
          let val = Math.round(i * this.targetNumber / this.maxUpdates);
          updateSteps.push(val);
        }
        updateSteps = [...new Set(updateSteps)];
      }
      if (this.isCountdown) {
        updateSteps = updateSteps.map(x => this.targetNumber - x);
        updateSteps.unshift(this.targetNumber);
        updateSteps.push(0);
        updateSteps = [...new Set(updateSteps)].filter(x => x >= 0);
      }

      let currentStepIdx = 0;

      animate(0, 1, {
        duration: this.duration,
        easing: "linear",
        onUpdate: latest => {
          const preNum = Math.round(this.dataset.preNumber);
          let progress = Math.max(0, Math.min(1, latest));
          let value = this.isCountdown
            ? Math.round(this.targetNumber * (1 - progress))
            : Math.round(this.targetNumber * progress);

          let newNum;
          if (this.targetNumber < this.maxUpdates) {
            newNum = value;
          } else {
            if (currentStepIdx >= updateSteps.length) return;
            const stepVal = updateSteps[currentStepIdx];
            if (
              (!this.isCountdown && value < stepVal) ||
              (this.isCountdown && value > stepVal)
            )
              return;
            newNum = stepVal;
            currentStepIdx++;
          }

          if (newNum !== preNum) {
            const preNumElem = $4('.hdt-pre-num', this);
            if (preNumElem) preNumElem.remove();

            const curNumElem = $4('.hdt-current-num', this);
            if (curNumElem) {
              curNumElem.classList.remove('hdt-current-num');
              curNumElem.classList.add('hdt-pre-num');
            }

            this.insertAdjacentHTML(
              'beforeend',
              `<span class="hdt-counter-num hdt-current-num">${newNum.toLocaleString()}</span>`
            );
            this.dataset.preNumber = newNum;
          }
        }
      });
    });
  }
}
customElements.define("hdt-card-counter", HdtCardCounter);

// Auto rotate text
class HdtRotateTexts extends HTMLElement {
  constructor() {
    super();
    this._interval = null;
    this._current = 0;
    this._autoplay = false;
    this._duration = 1000;
    this._spans = [];
    this._onMouseEnter = this._onMouseEnter.bind(this);
    this._onMouseLeave = this._onMouseLeave.bind(this);
  }

  connectedCallback() {
    this._autoplay = this.getAttribute('autoplay') === 'true';
    this._duration = parseInt(this.getAttribute('duration')) || 1000;

    this._spans = Array.from(this.querySelectorAll('span'));
    this._spans.forEach((el, i) => el.style.display = i === 0 ? 'inline' : 'none');

    if (this._autoplay) {
      this._start();
    } else {
      this.addEventListener('mouseenter', this._onMouseEnter);
      this.addEventListener('mouseleave', this._onMouseLeave);
    }
  }

  disconnectedCallback() {
    this._stop();
    this.removeEventListener('mouseenter', this._onMouseEnter);
    this.removeEventListener('mouseleave', this._onMouseLeave);
  }

  _onMouseEnter() {
    this._start();
  }
  _onMouseLeave() {
    this._stop();
  }

  _start() {
    if (this._interval) return;
    this._interval = setInterval(() => this._next(), this._duration);
  }
  _stop() {
    clearInterval(this._interval);
    this._interval = null;
  }

  _next() {
    if (!this._spans.length) return;
    this._spans[this._current].style.display = 'none';
    this._current = (this._current + 1) % this._spans.length;
    this._spans[this._current].style.display = 'inline';
  }
}

customElements.define('hdt-rotate-texts', HdtRotateTexts);

// Product qty chosen
class HdtQuantityChosen extends HTMLElement {
  constructor() {
    super();
    this._onRadioChange = this._onRadioChange.bind(this);
    this._onInputChange = this._onInputChange.bind(this);
  }

  connectedCallback() {
    this.radios = this.querySelectorAll('input[type="radio"][name="qty"]');
    this.input = this.querySelector('input[name="quantity"]');

    if (this.radios.length > 0) {
      const checked = Array.from(this.radios).some(r => r.checked);
      if (!checked) {
        this.radios[0].checked = true;
      }
      this._setQuantityFromCheckedRadio();
    }

    this.radios.forEach(radio => {
      radio.addEventListener('change', this._onRadioChange);
    });

    if (this.input) {
      this.input.addEventListener('input', this._onInputChange);
    }
  }

  disconnectedCallback() {
    if (this.radios) {
      this.radios.forEach(radio => {
        radio.removeEventListener('change', this._onRadioChange);
      });
    }
    if (this.input) {
      this.input.removeEventListener('input', this._onInputChange);
    }
  }

  _onRadioChange(e) {
    this._setQuantityFromCheckedRadio();
    this._dispatchQuantityUpdateEvent();
  }

  _onInputChange(e) {
    this._dispatchQuantityUpdateEvent();
  }

  _setQuantityFromCheckedRadio() {
    const checkedRadio = Array.from(this.radios).find(r => r.checked);
    if (checkedRadio && this.input) {
      this.input.value = checkedRadio.value;
    }
  }

  _dispatchQuantityUpdateEvent() {
    if (!this.input) return;
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
    // this.input.dispatchEvent(
    //   new QuantitySelectorUpdateEvent(
    //     parseInt(this.input.value),
    //     Number(this.input.dataset.index)
    //   )
    // );
  }
}

customElements.define('hdt-quantity-chosen', HdtQuantityChosen);

// Custom price
// Extend QtyPrice to create hdtCustomQtyPrice for custom element <hdt-custom-qty-price>
const QtyPrice = customElements.get('hdt-qty-price');
class hdtCustomQtyPrice extends QtyPrice {
    constructor() {
        super();
        this._onRadioChange = this._onRadioChange.bind(this);
        this._onQuantityChangeDelayed = this._onQuantityChangeDelayed.bind(this);
        this._planObserver = null;
        this._quantityObserver = null;
        this._appstleObserver = null;
        this._appstleMoTick = null; 
        this._pollTries = 0;
        this._qtyDelayT = null;

        this._oneShotCheckScheduled = false;
        this._oneShotCheckHandle = null;

        this._unbindAllQuantityRadios = this._unbindAllQuantityRadios.bind(this);
        this._ensureAppstleTexts = this._ensureAppstleTexts.bind(this);
        this._maybeScheduleOneShotCheck = this._maybeScheduleOneShotCheck.bind(this);
    }

    connectedCallback() {
        super.connectedCallback();

        this._qtyRadios = Array.from(document.querySelectorAll('input[type="radio"][name="qty"]'));
        this._qtyRadios.forEach(radio => {
            radio.addEventListener('change', this._onRadioChange);
        });

        this._planRadios = Array.from(document.querySelectorAll('input[type="radio"][name="selling_plan"]'));
        this._planRadios.forEach(radio => {
            radio.addEventListener('change', this._onRadioChange);
            radio.addEventListener('input', this._onRadioChange);
        });

        this._bindQuantityRadios();
        this._observePlanRadios();
        this._observeQuantityRadios();
        this._ensureAppstleTexts();
        this._observeAppstle();
        this._maybeScheduleOneShotCheck();

        this._pollTries = 0;
        this._pollForReady();
    }

    disconnectedCallback() {
        this._qtyRadios?.forEach(radio => {
            radio.removeEventListener('change', this._onRadioChange);
        });

        this._planRadios?.forEach(radio => {
            radio.removeEventListener('change', this._onRadioChange);
            radio.removeEventListener('input', this._onRadioChange);
        });

        this._unbindAllQuantityRadios();

        if (this._planObserver) this._planObserver.disconnect();
        if (this._quantityObserver) this._quantityObserver.disconnect();
        if (this._appstleObserver) this._appstleObserver.disconnect();

        if (this._qtyDelayT) {
            clearTimeout(this._qtyDelayT);
            this._qtyDelayT = null;
        }
        if (this._oneShotCheckHandle) {
            clearTimeout(this._oneShotCheckHandle);
            this._oneShotCheckHandle = null;
        }

        super.disconnectedCallback && super.disconnectedCallback();
    }

    _getScopeRoot() {
        return this.closest('.hdt-product-info__list') || document;
    }
    _appendOnce(target, cls, text) {
        if (!target) return;
        const t = (text || '').trim();
        if (!t) return;
        if (target.querySelector('.' + cls)) return; 
        const span = document.createElement('span');
        span.className = cls;
        span.textContent = t;
        target.appendChild(span);
    }
    _maybeScheduleOneShotCheck() {
        if (this._oneShotCheckScheduled) return;
        const root = this._getScopeRoot();
        if (root.querySelector('.appstle_subscription_radio_wrapper')) {
            this._oneShotCheckScheduled = true;
            this._oneShotCheckHandle = setTimeout(() => {
                this._oneShotCheckHandle = null;
                this._ensureAppstleTexts(); 
            }, 1000);
        }
    }

    _ensureAppstleTexts() {
      const root = this._getScopeRoot();
      root.querySelectorAll('.appstle_one_time_details_wrapper .appstle_one_time_text')
          .forEach(host => {
              if (!host.querySelector('.hdt-appstle_one_time_text--origin')) {
                  const firstNode = host.childNodes[0];
                  let originText = '';
                  if (firstNode && firstNode.nodeType === Node.TEXT_NODE) {
                      originText = firstNode.textContent.trim();
                  }

                  if (originText) {
                      const normalized = originText.replace(/\s+/g, ' ').trim().toLowerCase();
                      let displayText = originText;
                      if (normalized === 'one time purchase') {
                          displayText = 'One Time';
                      }

                      firstNode.textContent = '';
                      const wrap = document.createElement('span');
                      wrap.className = 'hdt-appstle_one_time_text--origin';
                      wrap.textContent = displayText;
                      host.insertBefore(wrap, host.firstChild);
                  }
              }

              if (!host.querySelector('.hdt-one-time-text-desc')) {
                  const s = document.createElement('span');
                  s.className = 'hdt-one-time-text-desc';
                  s.textContent = 'One Time Purchase';
                  host.appendChild(s);
              }
          });

      root.querySelectorAll('.appstle_subscription_radio_wrapper').forEach(radioWrapper => {
        const target = radioWrapper.querySelector('.appstle-text-and-badge-wrapper') || radioWrapper;
        const option = radioWrapper.closest('.appstle_subscription_wrapper_option') || radioWrapper;
        const sourceSingle = option.querySelector('.appstle_single_option_text');
        const sourceDesc   = option.querySelector('.appstleSellingPlanDescription');
        const singleText = (sourceSingle && sourceSingle.textContent) || '';
        this._appendOnce(target, 'hdt-appstle_single_option_text', singleText);

        if (sourceDesc && !target.querySelector('.hdt-appstleSellingPlanDescription')) {
          const tmp = document.createElement('div');
          tmp.innerHTML = sourceDesc.innerHTML;
          tmp.querySelectorAll('br').forEach(br => br.remove());
          tmp.querySelectorAll('p').forEach(p => {
            const span = document.createElement('span');
            while (p.firstChild) span.appendChild(p.firstChild);
            p.replaceWith(span);
          });

          const el = document.createElement('span');
          el.className = 'hdt-appstleSellingPlanDescription';
          el.innerHTML = tmp.innerHTML;
          target.appendChild(el);
        }
      });
    }

    _observeAppstle() {
        const root = this._getScopeRoot();
        if (this._appstleObserver) this._appstleObserver.disconnect();

        this._appstleObserver = new MutationObserver(() => {
            if (this._appstleMoTick) return;
            this._appstleMoTick = requestAnimationFrame(() => {
                this._appstleMoTick = null;
                this._ensureAppstleTexts();
                this._maybeScheduleOneShotCheck(); 
            });
        });
        this._appstleObserver.observe(root, { childList: true, subtree: true });
    }

    _bindQuantityRadios() {
        const scope = document.querySelector('.hdt-product-form__values') || document;
        this._quantityRadios = Array.from(
            scope.querySelectorAll('input[type="radio"][name="Quantity"]')
        );

        this._quantityRadios.forEach(radio => {
            radio.addEventListener('change', this._onQuantityChangeDelayed);
            radio.addEventListener('input', this._onQuantityChangeDelayed);
        });
    }

    _unbindAllQuantityRadios() {
        if (!this._quantityRadios) return;
        this._quantityRadios.forEach(radio => {
            radio.removeEventListener('change', this._onQuantityChangeDelayed);
            radio.removeEventListener('input', this._onQuantityChangeDelayed);
        });
        this._quantityRadios = null;
    }

    _onQuantityChangeDelayed() {
        const delay = 1;
        if (this._qtyDelayT) clearTimeout(this._qtyDelayT);
        this._qtyDelayT = setTimeout(() => this._onRadioChange(), delay);
        if (this._qtyDelayT) clearTimeout(this._qtyDelayT);
        this._qtyDelayT = setTimeout(() => this._onRadioChange(), delay + 50);
    }

    _observePlanRadios() {
        const planWrapper = document.querySelector('.appstle_subscription_wrapper') || document.body;
        this._planObserver = new MutationObserver(() => {
            this._planRadios?.forEach(radio => {
                radio.removeEventListener('change', this._onRadioChange);
                radio.removeEventListener('input', this._onRadioChange);
            });
            this._planRadios = Array.from(document.querySelectorAll('input[type="radio"][name="selling_plan"]'));
            this._planRadios.forEach(radio => {
                radio.addEventListener('change', this._onRadioChange);
                radio.addEventListener('input', this._onRadioChange);
            });

            this._ensureAppstleTexts();
            this._maybeScheduleOneShotCheck();
        });
        this._planObserver.observe(planWrapper, { childList: true, subtree: true });
    }

    _observeQuantityRadios() {
        const container = document.querySelector('.hdt-product-form__values') || document.body;
        this._quantityObserver = new MutationObserver(() => {
            this._unbindAllQuantityRadios();
            this._bindQuantityRadios();
        });
        this._quantityObserver.observe(container, { childList: true, subtree: true });
    }

    _pollForReady() {
        this._onRadioChange();
        this._pollTries = (this._pollTries || 0) + 1;
        if (!this._hasValidPlanPrice() && this._pollTries < 10) {
            setTimeout(() => this._pollForReady(), 120);
        }
    }

    _hasValidPlanPrice() {
        const planRadio = document.querySelector('input[type="radio"][name="selling_plan"]:checked');
        if (!planRadio) return false;
        let wrapper = planRadio.closest('.appstle_one_time_details_wrapper') || planRadio.closest('.appstle_subscription_wrapper_option');
        if (!wrapper) return false;
        const amountElem = wrapper.querySelector('.appstle_subscription_amount:not(.sr-only)');
        return !!amountElem && !!amountElem.textContent.trim();
    }

    _onRadioChange() {
        document.dispatchEvent(new CustomEvent("currency:update"));
    }
}

customElements.define('hdt-custom-qty-price', hdtCustomQtyPrice);

class HdtFlipCard extends HTMLElement {
  constructor() {
    super();
    this._onMouseEnter = this._onMouseEnter.bind(this);
    this._observer = null;
    this._flipped = false;
  }

  connectedCallback() {
    this.classList.add('hdt-flip-card');

    this._observer = new window.IntersectionObserver(
      (entries, observer) => {
        const entry = entries[0];
        if (entry.isIntersecting && entry.intersectionRatio >= 0.8 && !this._flipped) {
          this.classList.add('hdt-flipped');
          this._flipped = true;
        }
      },
      {
        threshold: [0.8]
      }
    );
    this._observer.observe(this);

    this.addEventListener('mouseenter', this._onMouseEnter);
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this._onMouseEnter);
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
  }

  _onMouseEnter() {
    this.classList.remove('hdt-flipped');
    this._flipped = false;
  }
}

customElements.define('hdt-flip-card', HdtFlipCard)

// Qoute reviews
class HdtQuoteReviews extends HTMLElement {
  constructor() {
    super();
    this._cardBtns = [];
    this._cards = [];
    this._avatars = [];
    this._active = 0;
    this._orders = [];
  }

  connectedCallback() {
    const cards = Array.from($$4('.hdt-qoute-review-card', this));
    const avatarsBox = $4('.hdt-qoute-avatars', this);
    avatarsBox.innerHTML = '';
    this._cardBtns = [];
    this._cards = cards;
    this._orders = cards.map((_, i) => i);
    cards.forEach((card, i) => {
      card.style.setProperty('--order', i + 1);
      card.classList.toggle('hdt-current-card', i === 0);
      const auAvatar = $4('.hdt-qoute-au-avatar', card);
      if (auAvatar) {
        const avatarImg = auAvatar.firstElementChild.cloneNode(true);
        const btn = document.createElement('button');
        btn.className = 'hdt-card-tag-btn';
        if (i === 0) btn.classList.add('hdt-current-btn');
        btn.type = 'button';
        btn.appendChild(avatarImg);
        btn.addEventListener('click', () => this._queueTo(i));
        btn.style.setProperty('--btn-order', i + 1); 
        avatarsBox.appendChild(btn);
        this._cardBtns.push(btn);
      }
    });

    this.style.setProperty('--count-cards', cards.length);
    this._updateUI();
  }

  _queueTo(index) {
    if (index === this._active) return;
    const len = this._cards.length;
    let steps = (index - this._active + len) % len;
    this._animateStack(steps);
    this._active = index;
    this._cardBtns.forEach((btn, i) =>
      btn.classList.toggle('hdt-current-btn', i === index)
    );
  }

  async _animateStack(steps) {
    for (let s = 0; s < steps; s++) {
      const topIdx = this._orders[0];
      const card = this._cards[topIdx];
      card.classList.add('hdt-exiting');
      await this._wait(150); 
      card.classList.remove('hdt-exiting');
      this._orders.push(this._orders.shift());
      this._updateUI();
      await this._wait(150); 
    }
  }

  _wait(ms) {
    return new Promise(res => setTimeout(res, ms));
  }

  _updateUI() {
    this._orders.forEach((idx, order) => {
      const card = this._cards[idx];
      card.style.setProperty('--order', order);
      card.classList.toggle('hdt-current-card', order === 0);
    });
  }
}

customElements.define('hdt-quote-reviews', HdtQuoteReviews);

// Product info list
class HdtProductInfoList extends HTMLElement {
  constructor() {
    super();
    this._obsInsert = null;
    this._obsJsonAdd = null;
    this._obsJsonAttr = null;
    this._didInitialUpdate = false;
    this._htmlReady = { sub: false, ot: false };
    this._jsonReady = false;
    this._isMutating = false;
    this._cachedRaw = null;
    this._cachedParsed = null;
    this._didInitialOtCheck = false;
  }

  connectedCallback() {
    this._scanAndInsert();
    this._updateHtmlReadyFlags();
    if (!this._tryInitialUpdate()) {
      this._armJsonReadyWatchers();
    }
    this._armInsertObserver();

    this.addEventListener('change', (ev) => {
      const t = ev.target;
      if (!t) return;
      const name = t.getAttribute('name');
      if (name === 'selling_plan' || name === 'Quantity') {
        this._updateAll();
      }
    });

    const reinsert = () => {
      this._scanAndInsert();
      this._updateHtmlReadyFlags();
      this._maybeRunInitialOnce();
    };
    document.addEventListener('shopify:section:load', reinsert);
    document.addEventListener('appstle:widget:loaded', reinsert);
    document.addEventListener('appstle:initialized', reinsert);
  }

  disconnectedCallback() {
    this._disconnect(this._obsInsert);
    this._disconnect(this._obsJsonAdd);
    this._disconnect(this._obsJsonAttr);
  }

  _scanAndInsert() {
    this._ensureInserted(
      '.appstle_sub_widget .appstle_subscription_radio_wrapper .appstle_subscription_amount_wrapper',
      '.hdt-price-per-bottle-wrap',
      `<div class="hdt-price-per-bottle-wrap"><div class="hdt-pr-per-bottle-discount"></div><div class="hdt-pr-per-bottle-origin"></div></div>
      <span class="hdt-bottle-unit-price"><span class="hdt-price-per-bottle"></span><span class="hdt-bottle-unit">/BOTTLE</span></span>`
    );

    this._ensureInserted(
      '.appstle_sub_widget .appstle_one_time_details_wrapper .appstle_one_time_price_wrapper',
      '.hdt-onetime-price-per-bottle-wrap',
      `<div class="hdt-onetime-price-per-bottle-wrap"><div class="hdt-onetime-pr-per-bottle-discount"></div><div class="hdt-onetime-pr-per-bottle-origin"></div></div>
      <span class="hdt-bottle-unit-price"><span class="hdt-price-per-bottle"></span><span class="hdt-bottle-unit">/BOTTLE</span></span>`
    );

    this._ensureMoneyCustomAdded();
    this._ensureInitialOtChecked();
  }

  _ensureMoneyCustomAdded() {
    const nodes = this.querySelectorAll('.hdt-qty-price--custom .hdt-money');
    nodes.forEach(n => {
      const parent = n.parentElement;
      if (!parent) return;
      const exists = parent.querySelector(':scope > .hdt-money--custom');
      if (!exists) {
        this._mutate(() => n.insertAdjacentHTML('afterend', '<span class="hdt-money--custom"></span>'));
      }
    });
  }

  _ensureInitialOtChecked() {
    if (this._didInitialOtCheck) return;
    const otInput = this.querySelector(
      '.appstle_sub_widget .appstle_one_time_details_wrapper input[name="selling_plan"]'
    );
    if (!otInput) return;
    this._didInitialOtCheck = true;
    if (otInput.checked) return;
    this._mutate(() => {
      otInput.checked = true;
      otInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  _ensureInserted(containerSelector, sentinelSelector, html) {
    const container = this.querySelector(containerSelector);
    if (!container) return;
    if (container.querySelector(sentinelSelector)) return;
    this._mutate(() => container.insertAdjacentHTML('beforeend', html));
  }

  _armInsertObserver() {
    if (this._obsInsert) return;
    this._obsInsert = new MutationObserver(() => {
      if (this._isMutating) return;
      this._scanAndInsert();
      this._updateHtmlReadyFlags();
      this._maybeRunInitialOnce();
    });
    this._obsInsert.observe(this, { childList: true, subtree: true });
  }

  _updateHtmlReadyFlags() {
    this._htmlReady.sub = !!this.querySelector('.appstle_subscription_amount_wrapper .hdt-price-per-bottle-wrap');
    this._htmlReady.ot  = !!this.querySelector('.appstle_one_time_price_wrapper .hdt-onetime-price-per-bottle-wrap');
  }

  _armJsonReadyWatchers() {
    if (!this._obsJsonAdd) {
      this._obsJsonAdd = new MutationObserver(() => {
        if (this._isMutating) return;
        const el = this._jsonEl();
        if (el) {
          if (el.getAttribute('data-product-data')) {
            this._tryInitialUpdate();
            this._disconnect(this._obsJsonAdd);
          } else {
            this._armJsonAttrWatcher(el);
            this._disconnect(this._obsJsonAdd);
          }
        }
      });
      this._obsJsonAdd.observe(this, { childList: true, subtree: true });
    }
    const el = this._jsonEl();
    if (el && !el.getAttribute('data-product-data')) {
      this._armJsonAttrWatcher(el);
    }
  }

  _armJsonAttrWatcher(el) {
    if (this._obsJsonAttr) return;
    this._obsJsonAttr = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type === 'attributes' && m.attributeName === 'data-product-data') {
          this._tryInitialUpdate();
          this._disconnect(this._obsJsonAttr);
          break;
        }
      }
    });
    this._obsJsonAttr.observe(el, { attributes: true, attributeFilter: ['data-product-data'] });
  }

  _jsonEl() {
    return this.querySelector('.appstle_stand_alone_price_display_selector');
  }

  _tryInitialUpdate() {
    const data = this._getProductData();
    if (!data) return false;
    this._jsonReady = true;
    this._maybeRunInitialOnce();
    return true;
  }

  _maybeRunInitialOnce() {
    if (this._didInitialUpdate) return;
    if (this._jsonReady && this._htmlReady.sub && this._htmlReady.ot) {
      this._didInitialUpdate = true;
      this._updateAll();
    }
  }

  _getProductData() {
    const el = this._jsonEl();
    if (!el) return null;
    let raw = el.getAttribute('data-product-data') || '';
    if (!raw) return null;
    if (raw === this._cachedRaw && this._cachedParsed) return this._cachedParsed;
    if (raw.includes('&quot;')) raw = raw.replaceAll('&quot;', '"');
    try {
      const parsed = JSON.parse(raw);
      this._cachedRaw = raw;
      this._cachedParsed = parsed;
      return parsed;
    } catch {
      return null;
    }
  }

  _enrichVariants(data) {
    const variants = Array.isArray(data.variants) ? data.variants : [];
    const list = variants.map((v) => {
      const title = String(v.title || v.option1 || '').trim();
      const m = /(\d+)/.exec(title);
      const pack = m ? Math.max(1, parseInt(m[1], 10)) : 1;
      const price = Number(v.price || 0);
      const unit_price = pack ? Math.round(price / pack) : price;
      let spPrice = null;
      if (Array.isArray(v.selling_plan_allocations) && v.selling_plan_allocations.length) {
        const sp = v.selling_plan_allocations[0];
        spPrice = Number((sp.price ?? sp.per_delivery_price ?? null));
      }
      const sp_unit_price = (spPrice != null) ? (pack ? Math.round(spPrice / pack) : spPrice) : null;
      return { id: v.id, title, pack, price, sp_price: spPrice, unit_price, sp_unit_price };
    });
    const max_unit_price = list.reduce((m, it) => (m == null ? it.unit_price : Math.max(m, it.unit_price)), null);
    const byTitle = new Map(list.map(v => [v.title.toLowerCase(), v]));
    return { variants: list, max_unit_price, byTitle };
  }

  _getSelectedQtyTitle() {
    const checked = this.querySelector('.hdt-product-form__values input[name="Quantity"]:checked');
    if (checked?.value) return String(checked.value).trim().toLowerCase();
    const first = this.querySelector('.hdt-product-form__values input[name="Quantity"]');
    return first?.value ? String(first.value).trim().toLowerCase() : '';
  }

  _formatMoney(cents) {
    const n = Number(cents || 0) / 100;
    return '$' + n.toFixed(2);
  }

  _updateAll() {
    const data = this._getProductData();
    if (!data) return;
    const enriched = this._enrichVariants(data);
    if (!enriched?.variants?.length) return;

    const qtyTitle = this._getSelectedQtyTitle();
    const found = enriched.byTitle.get(qtyTitle) || enriched.variants[0];

    const subDiscountCents = (found?.sp_unit_price != null) ? found.sp_unit_price : (found?.unit_price ?? null);
    const subOriginCents   = (enriched.max_unit_price != null) ? enriched.max_unit_price : null;
    const otDiscountCents  = (found?.unit_price != null) ? found.unit_price : null;
    const otOriginCents    = (enriched.max_unit_price != null) ? enriched.max_unit_price : null;

    const subDiscountEl = this.querySelector('.appstle_subscription_amount_wrapper .hdt-price-per-bottle-wrap .hdt-pr-per-bottle-discount');
    const subOriginEl   = this.querySelector('.appstle_subscription_amount_wrapper .hdt-price-per-bottle-wrap .hdt-pr-per-bottle-origin');
    const otDiscountEl  = this.querySelector('.appstle_one_time_price_wrapper .hdt-onetime-price-per-bottle-wrap .hdt-onetime-pr-per-bottle-discount');
    const otOriginEl    = this.querySelector('.appstle_one_time_price_wrapper .hdt-onetime-price-per-bottle-wrap .hdt-onetime-pr-per-bottle-origin');

    this._mutate(() => {
      if (subDiscountEl) subDiscountEl.textContent = (subDiscountCents != null) ? this._formatMoney(subDiscountCents) : '';
      if (subOriginEl)   subOriginEl.textContent   = (subOriginCents   != null) ? this._formatMoney(subOriginCents)   : '';
      if (otDiscountEl)  otDiscountEl.textContent  = (otDiscountCents  != null) ? this._formatMoney(otDiscountCents)  : '';
      if (otOriginEl)    otOriginEl.textContent    = (otOriginCents    != null) ? this._formatMoney(otOriginCents)    : '';
    });

    this._updateMoneyCustom(found);
  }

  _updateMoneyCustom(found) {
    const subChecked = !!this.querySelector('.appstle_subscription_radio_wrapper input[name="selling_plan"]:checked');
    const otChecked  = !!this.querySelector('.appstle_one_time_details_wrapper input[name="selling_plan"]:checked');
    let cents = null;
    if (subChecked) {
      cents = (found?.sp_price != null) ? found.sp_price : (found?.price ?? null);
    } else if (otChecked) {
      cents = (found?.price != null) ? found.price : null;
    }
    const els = this.querySelectorAll('.hdt-qty-price--custom .hdt-money--custom');
    this._mutate(() => {
      els.forEach(el => { el.textContent = (cents != null) ? this._formatMoney(cents) : ''; });
    });
  }

  _mutate(fn) {
    this._isMutating = true;
    try { fn(); } finally { this._isMutating = false; }
  }

  _disconnect(obs) {
    if (obs) try { obs.disconnect(); } catch {}
  }
}

customElements.define('hdt-product-info-list', HdtProductInfoList);

// Add BOTTLE text

/**
 
(function() {
  const OBS_MAP = new WeakMap(); 

  function formatMoneyPerBottle(total, qty) {
    if (!qty || isNaN(qty) || qty < 1) return '';
    if (!total) return '';
    const m = String(total).trim().match(/([^\d.,\-]*)([\d,]+(?:\.\d+)?)/);
    if (!m) return '';
    const currency = m[1] || '';
    const num = parseFloat(m[2].replace(/,/g, ''));
    if (isNaN(num)) return '';
    return currency + (num / qty).toFixed(2);
  }

  function getCurrentQuantity(container) {
    const checked = container.querySelector('input[type="radio"][name="Quantity"]:checked');
    if (!checked) return 1;
    const v = parseInt(checked.value, 10);
    return Number.isInteger(v) && v > 0 ? v : 1;
  }

  function ensureSubWrap(amountWrapperEl) {
    let wrap = amountWrapperEl.querySelector('.hdt-price-per-bottle-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'hdt-price-per-bottle-wrap';
      wrap.innerHTML = '<div class="hdt-pr-per-bottle-discount"></div><div class="hdt-pr-per-bottle-origin"></div>';
      const badge = amountWrapperEl.querySelector('.hdt-bottle-unit-price');
      if (badge) amountWrapperEl.insertBefore(wrap, badge);
      else amountWrapperEl.appendChild(wrap);
    }
    return {
      wrap,
      discEl: wrap.querySelector('.hdt-pr-per-bottle-discount'),
      originEl: wrap.querySelector('.hdt-pr-per-bottle-origin')
    };
  }

  function ensureOneTimeWrap(oneTimePriceWrapperEl) {
    let wrap = oneTimePriceWrapperEl.querySelector('.hdt-onetime-price-per-bottle-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'hdt-onetime-price-per-bottle-wrap';
      wrap.innerHTML =
        '<div class="hdt-onetime-pr-per-bottle-discount"></div>' +
        '<div class="hdt-onetime-pr-per-bottle-origin"></div>';
      const badge = oneTimePriceWrapperEl.querySelector('.hdt-bottle-unit-price');
      if (badge) oneTimePriceWrapperEl.insertBefore(wrap, badge);
      else oneTimePriceWrapperEl.appendChild(wrap);
    }
    return {
      wrap,
      discEl: wrap.querySelector('.hdt-onetime-pr-per-bottle-discount'),
      originEl: wrap.querySelector('.hdt-onetime-pr-per-bottle-origin')
    };
  }

  function computeOriginPerBottle(container, qty) {
    const sel1 = container.querySelector('.appstle_one_time_price_wrapper .appstle_subscription_amount_compare_at_price.transcy-money');
    if (sel1) return formatMoneyPerBottle(sel1.textContent, qty);
    const sel2 = container.querySelector('.appstle_one_time_price_wrapper .appstle_subscription_amount.transcy-money');
    if (sel2) return formatMoneyPerBottle(sel2.textContent, qty);
    const sel3 = container.querySelector('.appstle_subscription_amount_wrapper .appstle_subscription_compare_amount.transcy-money');
    if (sel3) return formatMoneyPerBottle(sel3.textContent, qty);
    const sel4 = container.querySelector('.appstle_subscription_amount_wrapper .appstle_subscription_amount.transcy-money');
    if (sel4) return formatMoneyPerBottle(sel4.textContent, qty);
    return '';
  }

  function setTextIfChanged(el, txt) {
    if (!el) return;
    if (el.textContent !== txt) el.textContent = txt;
  }

  function ensureBadgeAfterWrap(target, perBottleText) {
    let badge = target.querySelector(':scope > .hdt-bottle-unit-price');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'hdt-bottle-unit-price';
      badge.innerHTML = '<span class="hdt-price-per-bottle"></span><span class="hdt-bottle-unit">/BOTTLE</span>';
      target.appendChild(badge); 
    }
    const priceSpan = badge.querySelector('.hdt-price-per-bottle');
    setTextIfChanged(priceSpan, perBottleText);
  }

  function updateUnitAndPrice(container) {
    const qty = getCurrentQuantity(container);
    container.querySelectorAll('.appstle_subscription_amount_wrapper').forEach(amountWrap => {
      const discountEl = amountWrap.querySelector('.appstle_subscription_amount.transcy-money');
      const discountPerBottle = discountEl ? formatMoneyPerBottle(discountEl.textContent, qty) : '';
      const originPerBottle = computeOriginPerBottle(container, qty);
      const { wrap, discEl, originEl } = ensureSubWrap(amountWrap);
      setTextIfChanged(discEl, discountPerBottle || '');
      setTextIfChanged(originEl, originPerBottle || '');
      const priceSrc = discountEl ? formatMoneyPerBottle(discountEl.textContent, qty) : '';
      ensureBadgeAfterWrap(amountWrap, priceSrc);
    });

    container
      .querySelectorAll('.appstle_one_time_details_wrapper .appstle_one_time_price_wrapper')
      .forEach(oneTimeWrap => {
        const { wrap, discEl, originEl } = ensureOneTimeWrap(oneTimeWrap);

        const otAmount = oneTimeWrap.querySelector('.appstle_subscription_amount.transcy-money');
        const discText = otAmount ? formatMoneyPerBottle(otAmount.textContent, qty) : '';
        setTextIfChanged(discEl, discText);

        const otCompare = oneTimeWrap.querySelector('.appstle_subscription_amount_compare_at_price.transcy-money');
        if (otCompare) {
          const oriText = formatMoneyPerBottle(otCompare.textContent, qty);
          originEl.style.display = '';
          setTextIfChanged(originEl, oriText);
        } else {
          originEl.style.display = 'none';
          setTextIfChanged(originEl, '');
        }
        ensureBadgeAfterWrap(oneTimeWrap, discText);
      });

    container.querySelectorAll('.appstle_subscription_amount.transcy-money').forEach(el => {
      const p = el.parentElement;
      const inKnown =
        p && (p.classList.contains('appstle_subscription_amount_wrapper') ||
              p.classList.contains('appstle_one_time_price_wrapper'));
      if (!inKnown) {
        const per = formatMoneyPerBottle(el.textContent, qty);
        ensureBadgeAfterWrap(el, per);
      }
    });
  }

  function watchContainer(container) {
    if (container.dataset.hdtPricedInitialized === '1') return;
    container.dataset.hdtPricedInitialized = '1';
    if (container.querySelector('.appstle_subscription_amount.transcy-money')) {
      updateUnitAndPrice(container);
    }

    let rafScheduled = false;
    const scheduleUpdate = () => {
      if (rafScheduled) return;
      rafScheduled = true;
      requestAnimationFrame(() => {
        rafScheduled = false;
        updateUnitAndPrice(container);
      });
    };

    const obs = new MutationObserver(muts => {
      for (const m of muts) {
        if (m.type === 'childList') {
          if (
            (m.addedNodes && m.addedNodes.length &&
              Array.from(m.addedNodes).some(n =>
                n.nodeType === 1 && (
                  n.matches?.('.transcy-money, .appstle_subscription_amount_wrapper, .appstle_one_time_price_wrapper') ||
                  n.querySelector?.('.transcy-money, .appstle_subscription_amount_wrapper, .appstle_one_time_price_wrapper')
                )
              )
            ) ||
            (m.removedNodes && m.removedNodes.length)
          ) { scheduleUpdate(); break; }
        } else if (m.type === 'characterData') {
          scheduleUpdate(); break;
        } else if (m.type === 'attributes' && m.target?.classList?.contains?.('transcy-money')) {
          scheduleUpdate(); break;
        }
      }
    });
    obs.observe(container, { childList: true, subtree: true, characterData: true, attributes: true });

    const onChange = (e) => {
      if (e.target && e.target.matches('input[type="radio"][name="Quantity"]')) updateUnitAndPrice(container);
    };
    container.addEventListener('change', onChange, { passive: true });
    const section = container.closest('[data-section-id]') || container.closest('section, .shopify-section');
    const onUnload = (ev) => {
      const targetId = ev.detail && (ev.detail.sectionId || ev.detail.section_id);
      const thisId = section?.dataset?.sectionId || section?.id;
      if (targetId && thisId && String(targetId) !== String(thisId)) return;
      cleanup(container);
    };
    document.addEventListener('shopify:section:unload', onUnload);
    const docObs = new MutationObserver(() => {
      if (!document.body.contains(container)) cleanup(container);
    });
    docObs.observe(document.body, { childList: true, subtree: true });

    OBS_MAP.set(container, { obs, onChangeHandler: onChange, onUnloadHandler: onUnload, docObs });
  }

  function cleanup(container) {
    const reg = OBS_MAP.get(container);
    if (!reg) return;
    try { reg.obs.disconnect(); } catch(e){}
    try { reg.docObs.disconnect(); } catch(e){}
    try { container.removeEventListener('change', reg.onChangeHandler, { passive: true }); } catch(e){}
    try { document.removeEventListener('shopify:section:unload', reg.onUnloadHandler); } catch(e){}
    OBS_MAP.delete(container);
    delete container.dataset.hdtPricedInitialized;
  }

  function setup() {
    document.querySelectorAll('.hdt-product-info__list').forEach(watchContainer);
    const rootObs = new MutationObserver((muts) => {
      muts.forEach(m => {
        if (m.addedNodes && m.addedNodes.length) {
          m.addedNodes.forEach(n => {
            if (n.nodeType !== 1) return;
            if (n.matches?.('.hdt-product-info__list')) watchContainer(n);
            n.querySelectorAll?.('.hdt-product-info__list').forEach(watchContainer);
          });
        }
      });
    });
    rootObs.observe(document.documentElement, { childList: true, subtree: true });
  }

  setup();
})();

 */

// Auto expand Newletters on mobile
(() => {
  const initOnce = () => {
    try {
      if (window.innerWidth >= 768) return;
      const headingSel = '.hdt-footer-main .hdt-footer-newsletter .hdt-heading-f';
      const panelSel   = '.hdt-footer-main .hdt-footer-newsletter';
      const headingEl = document.querySelector(headingSel);
      if (!headingEl) return;
      const panelEl = document.querySelector(panelSel);
      if (!panelEl) return;
      if (!panelEl.classList.contains('open')) {
        headingEl.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      }
    } finally {}
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOnce, { once: true });
  } else {
    initOnce();
  }
})();

class HdtRatingHolder extends HTMLElement {
  constructor() {
    super();
    this._observer = null;
    this._timeout = null;
    this._cloned = false;
  }

  connectedCallback() {
    if (this._cloned) return;
    const found = document.querySelector('.jdgm-rev-widg__summary');
    if (found) {
      this._cloneSummary(found);
      return;
    }
    this._observer = new MutationObserver(() => {
      const el = document.querySelector('.jdgm-rev-widg__summary');
      if (el) {
        this._cloneSummary(el);
        this._disconnect();
      }
    });
    this._observer.observe(document.body, {
      childList: true,
      subtree: true
    })
    this._timeout = setTimeout(() => this._disconnect(), 5000);
  }

  _cloneSummary(el) {
    if (this._cloned) return;
    this._cloned = true;
    this.innerHTML = ''; 
    this.appendChild(el.cloneNode(true));
  }

  _disconnect() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
    if (this._timeout) {
      clearTimeout(this._timeout);
      this._timeout = null;
    }
  }

  disconnectedCallback() {
    this._disconnect();
  }
}

customElements.define('hdt-rating-holder', HdtRatingHolder);

class HdtShippingEstimate extends HTMLElement {
  constructor() {
    super();
    this.timer = null;
    this.currentTime = null; 
  }

  connectedCallback() {
    const truckRoad = $4('.hdt-truck-road', this);
    const truckRoadWidth = truckRoad.getBoundingClientRect().width;
    this.style.setProperty('--road-distance', truckRoadWidth + 'px');
    this.currentTime = this.dataset.currentTime
      ? new Date(this.dataset.currentTime)
      : new Date();

    this.update(); 
    this.timer = setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    if (this.timer) clearInterval(this.timer);
  }

  update() {
    if (this.currentTime) {
      this.currentTime.setSeconds(this.currentTime.getSeconds() + 1);
    } else {
      this.currentTime = new Date();
    }
    let now = this.currentTime;

    let cutoffStr = this.dataset.cutoffTime || "14:00";
    let [cutoffHour, cutoffMin] = cutoffStr.split(":").map(Number);

    let cutoff = new Date(now);
    cutoff.setHours(cutoffHour, cutoffMin, 0, 0);

    let cutoffRef = new Date(cutoff);
    if (now > cutoff) {
      cutoff.setDate(cutoff.getDate() + 1);
    }

    let diff = cutoff - now;
    diff = diff < 0 ? 0 : diff;
    let hours = Math.floor(diff / (1000 * 60 * 60));
    let mins = Math.floor((diff / (1000 * 60)) % 60);
    let secs = Math.floor((diff / 1000) % 60);

    let dayStart = new Date(cutoff);
    dayStart.setDate(cutoff.getDate() - 1);
    let totalPeriod = cutoff - dayStart;
    let passedPeriod = now - dayStart;
    let percentPassed = Math.min(Math.max(passedPeriod / totalPeriod, 0), 1) * 100;

    let baseShippingDays = Number(this.dataset.baseShippingDays) || 3;
    let deliveryDays = now < cutoffRef ? baseShippingDays : baseShippingDays + 1;
    let deliveryDate = new Date(now);
    deliveryDate.setDate(now.getDate() + deliveryDays);
    let day = deliveryDate.getDate().toString().padStart(2, '0');
    let month = (deliveryDate.getMonth() + 1).toString().padStart(2, '0');
    let year = deliveryDate.getFullYear();

    let $hour = this.querySelector('.hdt-remaining-hours');
    let $min = this.querySelector('.hdt-remaining-mins');
    let $sec = this.querySelector('.hdt-remaining-secs');
    let $delivery = this.querySelector('.hdt-delivery-date');
    if ($hour) $hour.textContent = hours;
    if ($min) $min.textContent = mins.toString().padStart(2, '0');
    if ($sec) $sec.textContent = secs.toString().padStart(2, '0');
    if ($delivery) $delivery.textContent = `${day}/${month}/${year}`;

    this.style.setProperty('--percent-passed', percentPassed);
  }
}

customElements.define('hdt-shipping-estimate', HdtShippingEstimate);

class HdtFreeShipNoti extends HTMLElement {
  constructor() {
    super();
    this._threshold = 0;
    this._total = 0;
    this._progressBar = null;
    this._unlockedMsg = null;
    this._unlockingMsg = null;
  }

  connectedCallback() {
    this._threshold = parseFloat(this.getAttribute("data-threshold") || "0");
    this._total = parseFloat(this.getAttribute("data-total-cart-price") || "0");

    this._progressBar = this.querySelector(".hdt-free-ship-progress");
    this._unlockedMsg = this.querySelector(".hdt-unlocked-msg");
    this._unlockingMsg = this.querySelector(".hdt-unlocking-msg");

    const percent = Math.min(100, (this._total / this._threshold) * 100);

    this.style.setProperty("--progress", `${percent}`);

    if (this._total >= this._threshold) {
      this._unlockedMsg.style.display = "block";
      this._unlockingMsg.style.display = "none";
    } else {
      this._unlockedMsg.style.display = "none";
      this._unlockingMsg.style.display = "block";
    }

    this.classList.add("inited");
  }
}

customElements.define("hdt-free-ship-noti", HdtFreeShipNoti);

class HdtImageWithTextsTab extends HTMLElement {
  constructor() {
    super();
    this.filterBtns = [];
    this.cards = [];
    this.onFilterClick = this.onFilterClick.bind(this);
  }
  connectedCallback() {
    this.filterBtns = Array.from(this.querySelectorAll('.hdt-iwt-filter-btn'));
    this.cards = Array.from(this.querySelectorAll('.hdt-image-with-text-card'));

    // Ensure only one aria-current
    let currentBtn = this.filterBtns.find(btn => btn.hasAttribute('aria-current'));
    if (!currentBtn) this.filterBtns[0].setAttribute('aria-current', 'true');

    this.filterBtns.forEach(btn => btn.addEventListener('click', this.onFilterClick));
  }

  onFilterClick(e) {
    const btn = e.currentTarget;
    // Remove aria-current from all, add to clicked
    this.filterBtns.forEach(b => b.removeAttribute('aria-current'));
    btn.setAttribute('aria-current', 'true');

    const cat = btn.dataset.cat || '';
    this.cards.forEach(card => {
      const categories = (card.dataset.category || '').split(',').map(c => c.trim());
      // Show all if cat is empty
      const show = !cat || categories.includes(cat);
      if (show) {
        card.removeAttribute('hidden');
      } else {
        card.setAttribute('hidden', '');
      }
    });
  }
}

customElements.define('hdt-image-with-texts-tab', HdtImageWithTextsTab);

class HdtCollectionWithBanner extends HTMLElement {
  constructor() {
    super();
    this._handleBtnClick = this._handleBtnClick.bind(this);
    this._supportClasses = {
      '.hdt-cwb-caption': ['hdt-c-font-D-DIN-BOLD'],
      '.hdt-cwb-title': ['hdt-h3', 'hdt-uppercase', 'hdt-c-font-D-DIN-BOLD'],
      '.hdt-cwb-desc': []
    };
  }

  connectedCallback() {
    this.textArea = $4('.hdt-cwb-text-area', this);
    if (!this.textArea) return;
    this._attachEvents();
    const activeBtn = $4('.hdt-cwb-filter-btn[aria-current="true"]', this);
    if (activeBtn) this._updateContent(activeBtn);
  }

  disconnectedCallback() {
    this._detachEvents();
  }

  _attachEvents() {
    this._buttons = Array.from($$4('.hdt-cwb-filter-btn', this));
    this._buttons.forEach(btn => btn.addEventListener('click', this._handleBtnClick));
  }

  _detachEvents() {
    if (!this._buttons) return;
    this._buttons.forEach(btn => btn.removeEventListener('click', this._handleBtnClick));
    this._buttons = null;
  }

  _handleBtnClick(e) {
    if (!e.currentTarget) return;
    this._updateContent(e.currentTarget);
  }

  _updateContent(btn) {
    if (this._buttons) {
      this._buttons.forEach(b => b.setAttribute('aria-current', b === btn ? 'true' : 'false'));
    }
    this._updateOrCreate('.hdt-cwb-caption', 'div', btn.getAttribute('data-caption') || '');
    this._updateOrCreate('.hdt-cwb-title', 'h2', btn.getAttribute('data-title') || '');
    this._updateOrCreate('.hdt-cwb-desc', 'div', btn.getAttribute('data-desc') || '');
  }

  _updateOrCreate(selector, tag, content) {
    let el = $4(selector, this.textArea);
    if (!el) {
      el = document.createElement(tag);
      el.classList.add(selector.replace('.', ''));
      (this._supportClasses[selector] || []).forEach(cls => el.classList.add(cls));
      this.textArea.appendChild(el);
    }
    el.textContent = content;
  }
}

customElements.define('hdt-collection-with-banner', HdtCollectionWithBanner);

class HdtArticle extends HTMLElement {
  static selectors = 'h1,h2,h3,h4,h5,h6';

  static get observedAttributes() { return ['data-toc-title']; }
  attributeChangedCallback(name, oldV, newV) {
    if (name === 'data-toc-title' && this.isConnected && oldV !== newV) {
      this.#debouncedRebuild();
    }
  }

  connectedCallback() {
    const article = this.querySelector(':scope > article') || this.querySelector('article');
    if (!article) return;

    let wrap = this.querySelector(':scope > .hdt-toc-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'hdt-toc-wrap';
      this.insertBefore(wrap, article);
    } else {
      if (wrap.nextElementSibling !== article) this.insertBefore(wrap, article);
      wrap.innerHTML = '';
    }

    this.#buildTOC(article, wrap);

    if (!this._observer) {
      this._observer = new MutationObserver(() => this.#debouncedRebuild());
      this._observer.observe(article, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  disconnectedCallback() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
    if (this._debounceTimer) {
      clearTimeout(this._debounceTimer);
      this._debounceTimer = null;
    }
  }

  #debouncedRebuild() {
    clearTimeout(this._debounceTimer);
    this._debounceTimer = setTimeout(() => {
      const article = this.querySelector('article');
      const wrap = this.querySelector(':scope > .hdt-toc-wrap');
      if (!article || !wrap) return;
      wrap.innerHTML = '';
      this.#buildTOC(article, wrap);
    }, 100);
  }

  #buildTOC(article, wrap) {
    const headings = Array.from(article.querySelectorAll(HdtArticle.selectors));
    if (!headings.length) return;
    const tocTitle = (this.getAttribute('data-toc-title') || '').trim();
    const base = this.#levelOf(headings[0]);
    const allowed = new Set([base, base + 1, base + 2].filter(n => n <= 6));

    const nav = document.createElement('nav');
    nav.className = 'hdt-toc';
    nav.setAttribute('aria-label', 'Table of contents');

    const listRoot = document.createElement('ol');
    listRoot.className = 'hdt-toc-list';

    if (tocTitle) {
      const titleEl = document.createElement('h2');
      titleEl.className = 'hdt-toc-title';
      titleEl.textContent = tocTitle;
      const titleId = this.#uniqueSlug('hdt-toc-title', this);
      titleEl.id = titleId;
      nav.setAttribute('aria-labelledby', titleId);
      nav.appendChild(titleEl);
    }

    nav.appendChild(listRoot);

    let currentLevel = 1;          
    let prevTagNum = base - 1;    
    const stack = [listRoot];     
    let included = 0;

    for (const h of headings) {
      const tagNum = this.#levelOf(h);

      if (!allowed.has(tagNum)) continue;
      if (included > 0 && tagNum > prevTagNum + 1) continue;

      if (!h.id) h.id = this.#uniqueSlug(this.#slugify(h.textContent || 'section'), article);

      const tocLevel = tagNum - base + 1; 
      if (tocLevel > 3) continue;

      if (tocLevel > currentLevel) {
        const sub = document.createElement('ol');
        sub.className = 'hdt-toc-sublist';
        const lastLi = stack[stack.length - 1].lastElementChild;
        if (!lastLi) continue; 
        lastLi.appendChild(sub);
        stack.push(sub);
        currentLevel = tocLevel;
      } else if (tocLevel < currentLevel) {
        while (currentLevel > tocLevel) {
          stack.pop();
          currentLevel--;
        }
      }

      const currentList = stack[stack.length - 1];

      const li = document.createElement('li');
      li.className = `hdt-toc-lv-${tocLevel}`;

      const a = document.createElement('a');
      a.href = `#${h.id}`;
      a.textContent = (h.textContent || '').trim();
      a.addEventListener('click', (ev) => {
        if (this.hasAttribute('smooth-scroll')) {
          ev.preventDefault();
          h.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.pushState(null, '', `#${h.id}`);
        }
      });

      li.appendChild(a);
      currentList.appendChild(li);

      prevTagNum = tagNum;
      included++;
    }

    if (!included) return;

    wrap.appendChild(nav);
  }

  #levelOf(el) {
    const m = el.tagName.match(/H([1-6])/i);
    return m ? Number(m[1]) : 6;
  }

  #slugify(text) {
    return (text || '')
      .toString()
      .normalize('NFD')                 
      .replace(/[\u0300-\u036f]/g, '')  
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .slice(0, 64) || 'section';
  }

  #uniqueSlug(base, scope) {
    let slug = base;
    let i = 2;
    while (scope.querySelector(`#${CSS.escape(slug)}`)) {
      slug = `${base}-${i++}`;
    }
    return slug;
  }
}

customElements.define('hdt-article', HdtArticle);

class HdtStorySlider extends HTMLElement {
  constructor(){
    super();
    this._slides = [];
    this._inners = [];
    this._centerIndex = 0;

    this._opts = {
      centerWidth: 268, gap: 16, levels: 5,
      innerRatio: [9,16], innerAlign: 'mid',
      animBase: 450, animScale: 0.25, animMax: 1200,
      animEase: 'cubic-bezier(.22,.72,.18,1)'
    };

    this._drag = { active:false, startX:0, lastX:0, deltaX:0, moved:false, ts:0 };

    this._onResize = this._onResize.bind(this);
    this._onPointerDown = this._onPointerDown.bind(this);
    this._onPointerMove = this._onPointerMove.bind(this);
    this._onPointerUp   = this._onPointerUp.bind(this);
    this._onKeyDown     = this._onKeyDown.bind(this);
    this._onClick       = this._onClick.bind(this);
    this._onWheel       = this._onWheel.bind(this);
    this._wheelAcc      = 0;
    this._onBigWheel   = this._onBigWheel.bind(this);
    this._bigWheelAcc  = 0;
  }

  connectedCallback(){
    const num = (a, def) => { const v = Number(this.getAttribute(a)); return Number.isNaN(v) ? def : v; };
    const str = (a, def) => (this.getAttribute(a) || def);
    this._opts.centerWidth = num('center-width', this._opts.centerWidth);
    this._opts.gap         = num('gap', this._opts.gap);
    this._opts.levels      = num('levels', this._opts.levels);

    const rStr = str('inner-ratio','9:16').trim();
    const rm = rStr.match(/^\s*(\d+)\s*[:/x]\s*(\d+)\s*$/);
    if (rm) this._opts.innerRatio = [parseInt(rm[1],10), parseInt(rm[2],10)];
    const align = str('inner-align','mid').toLowerCase();
    this._opts.innerAlign = (['top','mid','bottom'].includes(align) ? align : 'mid');

    this._opts.animBase  = num('anim-duration', this._opts.animBase);
    this._opts.animScale = num('anim-distance-scale', this._opts.animScale);
    this._opts.animMax   = num('anim-max', this._opts.animMax);
    this._opts.animEase  = str('anim-ease', this._opts.animEase);

    this._viewport   = $4('.hdt-viewport', this);
    this._viewport.addEventListener('wheel', this._onWheel, { passive: false });
    this._track      = $4('.hdt-track', this);
    this._navWrap    = $4('.hdt-big-milestone-intro-nav', this); 
    this._slides     = Array.from($$4('.hdt-track .hdt-slide', this));
    if (!this._viewport || !this._track || !this._slides.length) return;

    this._inners = this._slides.map(sl => {
      let inner = $4('.hdt-slide-inner', sl);
      if (!inner) {
        inner = document.createElement('div');
        inner.className = 'hdt-slide-inner';
        while (sl.firstChild) inner.appendChild(sl.firstChild);
        sl.appendChild(inner);
      }
      return inner;
    });

    this._milestones = Array.from($$4('.hdt-milestone-intro-item', this));

    this._bigWrap = $4('.hdt-big-milestone-intro', this) || $4('.hdt-big-milestone-intro');
    if (this._bigWrap) {
      this._bigWrap.addEventListener('wheel', this._onBigWheel, { passive: false });
    }

    this._collectBigMilestones();
    const initBig = this._slides[Math.floor(this._slides.length/2)]?.dataset.bigMilestone;
    const initIdx = this._bigValues?.length ? Math.max(0, this._bigValues.indexOf(String(initBig))) : 0;
    this._bigTicker = Number.isFinite(initIdx) ? initIdx : 0;
    this._buildBigMilestoneContent();
    this._buildBigMilestoneNav();

    this._centerIndex = Math.floor(this._slides.length/2);

    window.addEventListener('resize', this._onResize, { passive:true });
    this._viewport.classList.add('hdt-grab');
    this._viewport.addEventListener('pointerdown', this._onPointerDown);
    window.addEventListener('pointermove', this._onPointerMove, { passive:false });
    window.addEventListener('pointerup', this._onPointerUp);
    window.addEventListener('pointercancel', this._onPointerUp);
    this.addEventListener('keydown', this._onKeyDown);
    this._track.addEventListener('click', this._onClick);

    this._render(false);
    this._syncActive();
  }

  disconnectedCallback(){
    window.removeEventListener('resize', this._onResize);
    window.removeEventListener('pointermove', this._onPointerMove);
    window.removeEventListener('pointerup', this._onPointerUp);
    window.removeEventListener('pointercancel', this._onPointerUp);
    if (this._viewport) this._viewport.removeEventListener('pointerdown', this._onPointerDown);
    this.removeEventListener('keydown', this._onKeyDown);
    if (this._track) this._track.removeEventListener('click', this._onClick);
    if (this._viewport) this._viewport.removeEventListener('wheel', this._onWheel);
    if (this._bigWrap) this._bigWrap.removeEventListener('wheel', this._onBigWheel);
  }

  _onWheel(e){
    if (!e.ctrlKey){
      e.preventDefault();
      e.stopPropagation();
    }
    let delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
    if (e.deltaMode === 1) delta *= 16; 
    else if (e.deltaMode === 2) delta *= (this._viewport?.clientHeight || 600);
    const invert = this.hasAttribute('wheel-invert') ? -1 : 1;
    this._wheelAcc += delta * invert;
    const STEP = 120;
    while (this._wheelAcc >=  STEP){ this._wheelAcc -= STEP; this._shift(1,  true); }
    while (this._wheelAcc <= -STEP){ this._wheelAcc += STEP; this._shift(-1, true); }
  }

  _onBigWheel(e){
    if (!e.ctrlKey){
      e.preventDefault();
      e.stopPropagation();
    }
    let delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
    if (e.deltaMode === 1)       delta *= 16;
    else if (e.deltaMode === 2)  delta *= (this._bigWrap?.clientHeight || 600); 

    const invert = this.hasAttribute('wheel-invert') ? -1 : 1;
    this._bigWheelAcc += delta * invert;
    const STEP = 120;
    while (this._bigWheelAcc >=  STEP){ this._bigWheelAcc -= STEP; this._goNextBig(); }
    while (this._bigWheelAcc <= -STEP){ this._bigWheelAcc += STEP; this._goPrevBig(); }
  }

  _collectBigMilestones(){
    this._milestoneIndexMap = new Map();
    this._slides.forEach((sl, i) => {
      const v = sl.dataset.bigMilestone;
      if (!v) return;
      if (!this._milestoneIndexMap.has(v)) this._milestoneIndexMap.set(v, []);
      this._milestoneIndexMap.get(v).push(i);
    });

    const values = Array.from(this._milestoneIndexMap.keys());
    values.sort((a,b)=>{
      const na = +a, nb = +b;
      const aNum = !Number.isNaN(na), bNum = !Number.isNaN(nb);
      if (aNum && bNum) return na - nb;
      if (aNum && !bNum) return -1;
      if (!aNum && bNum) return 1;
      return String(a).localeCompare(String(b), undefined, { numeric: true });
    });
    this._bigValues = values;
  }

  _buildBigMilestoneContent(){
    if (!this._bigWrap) return;
    this._bigWrap.innerHTML = '';
    this._bigItems = this._bigValues.map(val => {
      const div = document.createElement('div');
      div.className = 'hdt-big-milestone-intro-item';
      div.dataset.bigMilestone = val;
      div.textContent = val;
      this._bigWrap.appendChild(div);
      return div;
    });
  }

  _buildBigMilestoneNav(){
    if (!this._navWrap) return;
    let prev = $4('.hdt-big-milestone-intro-item-nav--prev', this._navWrap);
    let next = $4('.hdt-big-milestone-intro-item-nav--next', this._navWrap);

    $$4(
      '.hdt-big-milestone-intro-item-nav:not(.hdt-big-milestone-intro-item-nav--prev):not(.hdt-big-milestone-intro-item-nav--next)',
      this._navWrap
    ).forEach(el => el.remove());

    if (!prev) {
      prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'hdt-big-milestone-intro-item-nav hdt-big-milestone-intro-item-nav--prev';
      prev.setAttribute('aria-label', 'Previous');
      prev.textContent = '‹';
      this._navWrap.insertBefore(prev, this._navWrap.firstChild);
    }

    prev.onclick = () => this.prev();

    if (!next) {
      next = document.createElement('button');
      next.type = 'button';
      next.className = 'hdt-big-milestone-intro-item-nav hdt-big-milestone-intro-item-nav--next';
      next.setAttribute('aria-label', 'Next');
      next.textContent = '›';
      this._navWrap.appendChild(next);
    }
    next.onclick = () => this.next();

    const insertBetweenPrevNext = (btn) => {
      if (prev && next) {
        this._navWrap.insertBefore(btn, next);
      } else if (prev) {
        prev.after(btn);
      } else if (next) {
        this._navWrap.insertBefore(btn, next);
      } else {
        this._navWrap.appendChild(btn);
      }
    };

    this._bigNavButtons = this._bigValues.map(val => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hdt-big-milestone-intro-item-nav';
      btn.dataset.bigMilestone = val;

      const sr = document.createElement('span'); 
      sr.className = 'sr-only';
      sr.textContent = val;
      btn.appendChild(sr);

      btn.addEventListener('click', () => this._goToBigMilestoneFirst(val));

      insertBetweenPrevNext(btn);
      return btn;
    });
  }

  _goPrevBig(){
    if (!this._bigValues?.length) return;
    const current = this._slides[this._centerIndex]?.dataset.bigMilestone;
    let i = this._bigValues.indexOf(current);
    if (i === -1) i = 0;
    i = (i - 1 + this._bigValues.length) % this._bigValues.length;
    this._goToBigMilestoneFirst(this._bigValues[i]);
  }

  _goNextBig(){
    if (!this._bigValues?.length) return;
    const current = this._slides[this._centerIndex]?.dataset.bigMilestone;
    let i = this._bigValues.indexOf(current);
    if (i === -1) i = -1;
    i = (i + 1) % this._bigValues.length;
    this._goToBigMilestoneFirst(this._bigValues[i]);
  }

  _goToBigMilestoneFirst(value){
    const indices = this._milestoneIndexMap.get(String(value)) || [];
    if (!indices.length) return;
    const targetIndex = indices[0]; 
    const offset = this._signedOffset(targetIndex);
    if (offset !== 0) this._shift(offset);
  }

  next(){ this._shift(1); }
  prev(){ this._shift(-1); }
  get index(){ return this._centerIndex; }

  _onResize(){ this._render(false); }
  _onKeyDown(e){
    if (e.key === 'ArrowRight'){ this.next(); e.preventDefault(); }
    else if (e.key === 'ArrowLeft'){ this.prev(); e.preventDefault(); }
  }

  _onPointerDown(e){
    if (e.button !== 0) return;
    this._drag.active = true;
    this._drag.startX = this._drag.lastX = e.clientX;
    this._drag.deltaX = 0;
    this._drag.moved  = false;
    this._drag.ts     = performance.now();
    this._viewport.classList.add('hdt-grabbing');
  }
  _onPointerMove(e){
    if (!this._drag.active) return;
    e.preventDefault();
    const dx = e.clientX - this._drag.lastX;
    this._drag.lastX = e.clientX;
    this._drag.deltaX += dx;
    if (Math.abs(this._drag.lastX - this._drag.startX) > 5) this._drag.moved = true;
    const step = 60;
    while (this._drag.deltaX <= -step){ this._drag.deltaX += step; this._shift(1, true); }
    while (this._drag.deltaX >=  step){ this._drag.deltaX -= step; this._shift(-1, true); }
  }
  _onPointerUp(){
    if (!this._drag.active) return;
    this._viewport.classList.remove('hdt-grabbing');
    const totalDx = this._drag.lastX - this._drag.startX;
    const dt = performance.now() - this._drag.ts;
    const v  = Math.abs(totalDx) / Math.max(dt,1);
    if (Math.abs(totalDx) > 30 || v > 0.6){
      if (totalDx < 0) this._shift(1);
      else if (totalDx > 0) this._shift(-1);
      else this._render(true);
    } else {
      this._render(true);
    }
    this._drag.active = false;
    this._drag.deltaX = 0;
  }
  _onClick(e){
    if (this._drag.moved) return;
    const slide = e.target.closest('.hdt-slide');
    if (!slide || !this._track.contains(slide)) return;
    const i = this._slides.indexOf(slide);
    if (i === -1) return;
    const offset = this._signedOffset(i);
    if (offset !== 0) this._shift(offset);
  }

  _wrapIndex(i){ const n = this._slides.length; return ((i % n) + n) % n; }
  _signedOffset(i){
    const n = this._slides.length;
    let d = i - this._centerIndex;
    const half = Math.floor(n/2);
    if (d >  half) d -= n;
    if (d < -half) d += n;
    return d;
  }
  _widthForLevel(lvl){
    const capped = Math.min(this._opts.levels, Math.max(0, lvl));
    return this._opts.centerWidth * Math.pow(0.9, capped);
  }
  _innerHeightForWidth(w){ return Math.round(w * (this._opts.innerRatio[1] / this._opts.innerRatio[0])); }
  _computeDurationForDistance(dist, soft){
    const base = soft ? Math.max(180, this._opts.animBase * 0.6) : this._opts.animBase;
    return Math.min(this._opts.animMax, Math.round(base * (1 + dist * this._opts.animScale)));
  }

  _shift(step = 1, soft = false){
    const n = this._slides.length;
    if (!n) return;

    const prevSlide = this._slides[this._centerIndex];
    const prevBig   = prevSlide?.dataset.bigMilestone;
    const sgn       = Math.sign(step) || 1;   

    this._centerIndex = this._wrapIndex(this._centerIndex + step);

    const nextSlide = this._slides[this._centerIndex];
    const nextBig   = nextSlide?.dataset.bigMilestone;

    if (prevBig !== nextBig && this._bigValues && this._bigValues.length){
      const nB = this._bigValues.length;
      const a  = Math.max(0, this._bigValues.indexOf(String(prevBig)));
      const b  = Math.max(0, this._bigValues.indexOf(String(nextBig)));
      if (a >= 0 && b >= 0){
        const delta = (sgn > 0)
          ? ((b - a + nB) % nB)   
          : -((a - b + nB) % nB);    
        this._bigTicker = (this._bigTicker ?? a) + delta;
      }
    }

    this._lastDir = sgn;

    this._render(true, soft);
    this._syncActive();
    this.dispatchEvent(new CustomEvent('change', { detail:{ index:this._centerIndex } }));
  }

  _render(animate = true, soft = false){
    const n = this._slides.length; if (!n) return;
    const half = Math.floor(n/2);
    const widths = new Map(); widths.set(0, this._opts.centerWidth);
    for (let k=1;k<=half;k++){ const w=this._widthForLevel(k); widths.set(k,w); widths.set(-k,w); }

    const pos = new Map(); pos.set(0, 0);
    let prev = widths.get(0), acc = 0;
    for (let k=1;k<=half;k++){ const w=widths.get(k); acc += (prev/2) + (w/2) + this._opts.gap; pos.set(k, acc); prev = w; }
    prev = widths.get(0); acc = 0;
    for (let k=1;k<=half;k++){ const w=widths.get(-k); acc += (prev/2) + (w/2) + this._opts.gap; pos.set(-k, -acc); prev = w; }

    const outerH = this._innerHeightForWidth(this._opts.centerWidth);
    this._viewport.style.height = outerH + 'px';
    this._track.style.height    = outerH + 'px';

    for (let i=0;i<n;i++){
      const el = this._slides[i];
      const inner = this._inners[i];
      const d  = this._signedOffset(i);
      const ad = Math.abs(d);
      const w  = Math.round(widths.get(d));
      const x  = Math.round(pos.get(d));
      const z  = (half + 1) - ad;
      const far = Math.min(1, ad / (this._opts.levels + 1));
      const opacity = 1 - far * 0.15;

      if (!animate) el.style.transitionDuration = '0ms';
      else el.style.transitionDuration = this._computeDurationForDistance(ad, soft) + 'ms';
      el.style.transitionTimingFunction = this._opts.animEase;

      el.classList.toggle('hdt-slide--active', d === 0);
      el.style.zIndex = String(z);
      el.style.opacity = opacity.toFixed(3);
      el.style.width = w + 'px';
      el.style.height = outerH + 'px';
      el.style.transform = `translateX(calc(-50% + ${x}px))`;

      const ih = this._innerHeightForWidth(w);
      inner.style.height = ih + 'px';
      let topPx = 0;
      if (this._opts.innerAlign === 'mid') topPx = Math.max(0, Math.round((outerH - ih) / 2));
      else if (this._opts.innerAlign === 'bottom') topPx = Math.max(0, outerH - ih);
      inner.style.top = topPx + 'px';
    }
  }

  _buildBigMilestoneContent(){
    if (!this._bigWrap) return;
    this._bigWrap.innerHTML = '';
    this._bigItems = this._bigValues.map(val => {
      const div = document.createElement('div');
      div.className = 'hdt-big-milestone-intro-item';
      div.dataset.bigMilestone = val;
      div.textContent = val;
      this._bigWrap.appendChild(div);
      return div;
    });
  }

  _updateBigStack(currentValue){
    if (!this._bigItems || !this._bigItems.length) return;
    const n = this._bigValues.length; if (!n) return;
    const activeIdx = Math.max(0, this._bigValues.indexOf(String(currentValue)));
    if (this._bigTicker == null) this._bigTicker = activeIdx;
    const cur = ((this._bigTicker % n) + n) % n;
    for (let i = 0; i < n; i++){
      const el = this._bigItems[i];
      let rel = i - cur;
      while (rel >  2) rel -= n;
      while (rel < -2) rel += n;

      el.dataset.pos = String(rel);
      el.classList.toggle('hdt-big-milestone-intro-item--active', i === activeIdx);
      el.classList.toggle('hdt-hidden', Math.abs(rel) > 2);
    }
    const dur = this._computeDurationForDistance(1, false);
    this._bigItems.forEach(el => {
      el.style.transitionDuration = dur + 'ms';
      el.style.transitionTimingFunction = this._opts.animEase;
    });
  }

  _syncActive(){
    const activeSlide = this._slides[this._centerIndex];

    const ctrl = activeSlide?.getAttribute('aria-controls');
    if (ctrl){
      this._milestones.forEach(el => {
        el.classList.toggle('hdt-milestone-intro-item--active', el.id === ctrl);
      });
    }

    const val = activeSlide?.dataset.bigMilestone;
    this._updateBigStack(val);

    if (this._bigNavButtons){
      this._bigNavButtons.forEach(btn => {
        btn.classList.toggle('hdt-big-milestone-intro-item--active', btn.dataset.bigMilestone === val);
      });
    }
  }
}

customElements.define('hdt-story-slider', HdtStorySlider);

// Bundle ======================
class HdtEzzBundle extends HTMLElement {
  constructor() {
    super();
    this._contentRoot = null;
    this._selectedTarget = null;
    this._contentObserver = null;
    this._rafSync = 0;
    this._connected = false;

    this._cloneCleanups = [];
    this._selectedCount = null;

    this._docObserver = null;
    this._planSourceSection = null;
    this._planOrigSwitchEl = null;
    this._planOrigSwitchCleanup = null;
    this._planLastChecked = null;
    this._planCloneCleanups = [];

    this._progressTargetSeen = false;
    this._progressSourceNode = null;

    this._checkoutSourceNode = null;
    this._checkoutTargetSeen = false;
    this._checkoutDelayTimer = 0;
    this._checkoutCloneCleanups = [];

    this._qtyDirty = false;
    this._qtyListenerBound = false;

    this._subtotalDelayTimer = 0;
  }

  connectedCallback() {
    this._connected = true;
    this._selectedTarget = this.querySelector('.hdt-ezz-bundle-selected-products');
    this._contentRoot   = this.querySelector('.hdt-ezz-bundle-content');
    if (!this._selectedTarget || !this._contentRoot) return;

    this._observeContentRoot();
    this._observeDocumentForPlan();
    this._bindQtyEvents();
    this._scheduleSync();
  }

  disconnectedCallback() {
    this._connected = false;
    this._disconnectAll();

    this._detachCloneHandlers();
    if (this._selectedTarget) this._selectedTarget.replaceChildren();
    this._selectedCount = null;

    this._detachPlanCloneHandlers();
    this._detachPlanOrigSwitchListener();
    const t = this._getSinglePlanTarget();
    if (t) t.replaceChildren();
    this._planSourceSection = null;
    this._planOrigSwitchEl = null;
    this._planLastChecked = null;

    const p = this._getProgressTarget();
    if (p) p.replaceChildren();
    this._progressTargetSeen = false;
    this._progressSourceNode = null;

    const ct = this._getCheckoutTargetInThisCE();
    this._clearCheckoutDelay();
    this._detachCheckoutCloneHandlers();
    if (ct) ct.replaceChildren();
    this._checkoutSourceNode = null;
    this._checkoutTargetSeen = false;

    const st = this._getSubtotalTargetInThisCE();
    if (st) st.replaceChildren();

    this._unbindQtyEvents();
    this._qtyDirty = false;

    this._clearSubtotalDelay();
  }

  _scheduleSync() {
    if (!this._connected) return;
    if (this._rafSync) cancelAnimationFrame(this._rafSync);
    this._rafSync = requestAnimationFrame(() => {
      this._rafSync = 0;
      this._syncSelectedProducts_ByCountOrQty();
      this._maybeSetupPlanSourceAndTarget();
      this._maybeSyncProgressOnTargetAppeared();
      this._maybeSyncProgressOnSourceChanged();
      this._maybeSyncCheckoutOnTargetAppeared();
      this._maybeSyncCheckoutOnSourceChanged();
    });
  }

  _disconnectAll() {
    if (this._contentObserver) { this._contentObserver.disconnect(); this._contentObserver = null; }
    if (this._docObserver)     { this._docObserver.disconnect();     this._docObserver = null; }
    if (this._rafSync) { cancelAnimationFrame(this._rafSync); this._rafSync = 0; }
  }

  _observeContentRoot() {
    if (this._contentObserver) this._contentObserver.disconnect();
    this._contentObserver = new MutationObserver(() => this._scheduleSync());
    this._contentObserver.observe(this._contentRoot, { childList: true, subtree: true, characterData: true });
  }

  _bindQtyEvents() {
    if (this._qtyListenerBound) return;
    const isQtyEventTarget = (el) => {
      if (!el) return false;
      if (el.matches('input.ab-product-quantity, .ab-product-quantity, .ab-product-quantity-button, .ab-product-quantity-inc-button, .ab-product-quantity-dec-button')) return true;
      if (el.closest('.ab-product-quantity-button-content')) return true;
      if (el.closest('.ab-product-quantity')) return true;
      return false;
    };
    const handler = (e) => {
      if (!isQtyEventTarget(e.target)) return;
      this._qtyDirty = true;
      this._scheduleSync();
      this._syncProgressDiscount(true);
    };
    this._qtyHandler = handler;
    this._contentRoot.addEventListener('change', handler, true);
    this._contentRoot.addEventListener('input', handler, true);
    this._contentRoot.addEventListener('click', handler, true);
    this._qtyListenerBound = true;
  }

  _unbindQtyEvents() {
    if (!this._qtyListenerBound) return;
    this._contentRoot.removeEventListener('change', this._qtyHandler, true);
    this._contentRoot.removeEventListener('input', this._qtyHandler, true);
    this._contentRoot.removeEventListener('click', this._qtyHandler, true);
    this._qtyListenerBound = false;
    this._qtyHandler = null;
  }

  _detachCloneHandlers() {
    for (const off of this._cloneCleanups) { try { off(); } catch(_){} }
    this._cloneCleanups.length = 0;
  }

  _syncSelectedProducts_ByCountOrQty() {
    if (!this._selectedTarget || !this._contentRoot) return;

    const container = this._contentRoot.querySelector('.ab-selected-product-container');

    if (!container) {
      if (this._selectedCount !== null || this._qtyDirty) {
        this._detachCloneHandlers();
        this._selectedTarget.replaceChildren();
        this._selectedCount = null;
        this._qtyDirty = false;
        this._syncProgressDiscount(true);
        this._syncCheckout(true);
        this._syncSubtotalFromCheckout();
      }
      return;
    }

    const sections = Array.from(container.querySelectorAll('.ab-selected-product-section'));
    const newCount = sections.length;

    if (this._selectedCount === newCount && !this._qtyDirty) return;

    this._detachCloneHandlers();

    if (newCount === 0) {
      this._selectedTarget.replaceChildren();
      this._selectedCount = 0;
      this._qtyDirty = false;
      this._syncProgressDiscount(true);
      this._syncCheckout(true);
      this._syncSubtotalFromCheckout();
      return;
    }

    const frag = document.createDocumentFragment();

    sections.forEach((srcSec, secIdx) => {
      const clone = srcSec.cloneNode(true);
      clone.querySelectorAll('[id]').forEach(el => (el.id = ''));

      const cloneRemove = clone.querySelector('.ab-product-remove-button');
      if (cloneRemove) {
        const onClick = (e) => {
          e.preventDefault(); e.stopPropagation();
          const cont = this._contentRoot.querySelector('.ab-selected-product-container');
          if (!cont) return;
          const curSections = Array.from(cont.querySelectorAll('.ab-selected-product-section'));
          const origSection = curSections[secIdx];
          if (!origSection) return;
          const origBtn = origSection.querySelector('.ab-product-remove-button');
          if (!origBtn) return;
          if (origBtn.disabled || origBtn.getAttribute('aria-disabled') === 'true') return;
          origBtn.click();
        };
        const onKey = (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); cloneRemove.click(); }
        };
        cloneRemove.addEventListener('click', onClick, { passive: false });
        cloneRemove.addEventListener('keydown', onKey);
        this._cloneCleanups.push(() => {
          cloneRemove.removeEventListener('click', onClick, { passive: false });
          cloneRemove.removeEventListener('keydown', onKey);
        });
      }

      frag.appendChild(clone);
    });

    this._selectedTarget.replaceChildren(frag);
    this._selectedCount = newCount;
    this._qtyDirty = false;
    this._syncProgressDiscount(true);
    this._syncCheckout(true);
    this._syncSubtotalFromCheckout();
  }

  _observeDocumentForPlan() {
    if (this._docObserver) this._docObserver.disconnect();
    this._docObserver = new MutationObserver(() => this._scheduleSync());
    this._docObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  _getSinglePlanTarget() { return document.querySelector('.hdt-ezz-bundle-plan-selection'); }
  _findPlanSourceSectionInThisCE() { return this.querySelector('.ab-heading-selling-plan-section') || null; }

  _detachPlanCloneHandlers() {
    for (const off of this._planCloneCleanups) { try { off(); } catch(_){} }
    this._planCloneCleanups.length = 0;
  }

  _detachPlanOrigSwitchListener() {
    if (this._planOrigSwitchCleanup) {
      try { this._planOrigSwitchCleanup(); } catch(_) {}
      this._planOrigSwitchCleanup = null;
    }
    this._planOrigSwitchEl = null;
    this._planLastChecked = null;
  }

  _clearSubtotalDelay() {
    if (this._subtotalDelayTimer) {
      clearTimeout(this._subtotalDelayTimer);
      this._subtotalDelayTimer = 0;
    }
  }

  _bindPlanOrigSwitchListener() {
    if (!this._planSourceSection) return;
    const sw = this._planSourceSection.querySelector('.ab-heading-selling-plan-switch-input');
    if (sw === this._planOrigSwitchEl) return;
    if (this._planOrigSwitchEl && this._planOrigSwitchEl !== sw) this._detachPlanOrigSwitchListener();
    if (sw) {
      this._planLastChecked = !!sw.checked;
      const onChange = () => {
        const now = !!sw.checked;
        if (now !== this._planLastChecked) {
          this._planLastChecked = now;
          this._clonePlanNow();
          this._syncCheckout(true);
          this._clearSubtotalDelay();
          this._subtotalDelayTimer = setTimeout(() => {
            this._subtotalDelayTimer = 0;
            this._syncSubtotalFromCheckout();
          }, 50);
        }
      };
      sw.addEventListener('change', onChange);
      sw.addEventListener('input', onChange);
      this._planOrigSwitchCleanup = () => {
        sw.removeEventListener('change', onChange);
        sw.removeEventListener('input', onChange);
      };
      this._planOrigSwitchEl = sw;
    }
  }

  _maybeSetupPlanSourceAndTarget() {
    const target = this._getSinglePlanTarget();
    const newSrc = this._findPlanSourceSectionInThisCE();
    if (newSrc && newSrc !== this._planSourceSection) {
      this._planSourceSection = newSrc;
      this._detachPlanOrigSwitchListener();
      this._bindPlanOrigSwitchListener();
      this._clonePlanNow();
      this._syncCheckout(true);
      this._clearSubtotalDelay();
      this._subtotalDelayTimer = setTimeout(() => {
        this._subtotalDelayTimer = 0;
        this._syncSubtotalFromCheckout();
      }, 50);
      return;
    }
    if (!newSrc) {
      this._planSourceSection = null;
      this._detachPlanOrigSwitchListener();
      if (target) target.replaceChildren();
    }
  }

  _clonePlanSectionClean(node) {
    const c = node.cloneNode(true);
    c.querySelectorAll('[id]').forEach(el => (el.id = ''));
    return c;
  }

  _clonePlanNow() {
    const target = this._getSinglePlanTarget();
    if (!target || !this._planSourceSection) return;
    this._detachPlanCloneHandlers();
    const clone = this._clonePlanSectionClean(this._planSourceSection);
    const cloneSwitch = clone.querySelector('.ab-heading-selling-plan-switch-input')
                      || clone.querySelector('.ab-heading-selling-plan-switch');
    const origSwitch  = this._planOrigSwitchEl;
    if (cloneSwitch && origSwitch) {
      const forwardClick = (e) => {
        e.preventDefault(); e.stopPropagation();
        if (origSwitch.disabled || origSwitch.getAttribute('aria-disabled') === 'true') return;
        origSwitch.click();
      };
      const forwardKey = (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); cloneSwitch.click(); }
      };
      cloneSwitch.addEventListener('click', forwardClick, { passive: false });
      cloneSwitch.addEventListener('keydown', forwardKey);
      this._planCloneCleanups.push(() => {
        cloneSwitch.removeEventListener('click', forwardClick, { passive: false });
        cloneSwitch.removeEventListener('keydown', forwardKey);
      });
    }
    target.replaceChildren(clone);
  }

  _getProgressTarget() {
    return document.querySelector('.hdt-ezz-bundle-progress-step-discount');
  }

  _findProgressSourceInThisCE() {
    return this._contentRoot.querySelector('.ab-tiered-discount-progress-step-discount-section') || null;
  }

  _maybeSyncProgressOnTargetAppeared() {
    const t = this._getProgressTarget();
    const exists = !!t;
    if (exists && !this._progressTargetSeen) this._syncProgressDiscount(true);
    this._progressTargetSeen = exists;
  }

  _cloneProgressClean(node) {
    const c = node.cloneNode(true);
    c.querySelectorAll('[id]').forEach(el => (el.id = ''));
    return c;
  }

  _maybeSyncProgressOnSourceChanged() {
    const target = this._getProgressTarget();
    const src = this._findProgressSourceInThisCE();
    if (!target) return;
    if (!src) {
      if (this._progressSourceNode) {
        target.replaceChildren();
        this._progressSourceNode = null;
      }
      return;
    }
    if (src !== this._progressSourceNode) {
      this._progressSourceNode = src;
      this._syncProgressDiscount(true);
    }
  }

  _syncProgressDiscount(force = false) {
    const target = this._getProgressTarget();
    const source = this._findProgressSourceInThisCE();
    if (!target) return;
    if (!source) { target.replaceChildren(); return; }
    if (force) {
      const clone = this._cloneProgressClean(source);
      target.replaceChildren(clone);
    }
  }

  _getCheckoutTargetInThisCE() {
    return this.querySelector('.hdt-ezz-bundle-checkout');
  }

  _getSubtotalTargetInThisCE() {
    return this.querySelector('.hdt-ezz-bundle-subtotal');
  }

  _findCheckoutSourceInThisCE() {
    return this._contentRoot.querySelector('.ab-flex.ab-tiered-discount-progress-step-checkout-wrapper') || null;
  }

  _findCheckoutButtonInThisCE() {
    const src = this._findCheckoutSourceInThisCE();
    if (!src) return null;
    return src.querySelector('.ab-dynamic-bundle-checkout-button') || null;
  }

  _maybeSyncCheckoutOnTargetAppeared() {
    const t = this._getCheckoutTargetInThisCE();
    const exists = !!t;
    if (exists && !this._checkoutTargetSeen) this._syncCheckout(true);
    this._checkoutTargetSeen = exists;
  }

  _maybeSyncCheckoutOnSourceChanged() {
    const target = this._getCheckoutTargetInThisCE();
    const src = this._findCheckoutSourceInThisCE();
    if (!target) return;
    if (!src) {
      this._clearCheckoutDelay();
      this._detachCheckoutCloneHandlers();
      if (this._checkoutSourceNode) {
        target.replaceChildren();
        this._checkoutSourceNode = null;
      }
      return;
    }
    if (src !== this._checkoutSourceNode) {
      this._checkoutSourceNode = src;
      this._syncCheckout(true);
    }
  }

  _cloneCheckoutClean(node) {
    const c = node.cloneNode(true);
    c.querySelectorAll('[id]').forEach(el => (el.id = ''));
    return c;
  }

  _clearCheckoutDelay() {
    if (this._checkoutDelayTimer) {
      clearTimeout(this._checkoutDelayTimer);
      this._checkoutDelayTimer = 0;
    }
  }

  _detachCheckoutCloneHandlers() {
    for (const off of this._checkoutCloneCleanups) { try { off(); } catch(_){} }
    this._checkoutCloneCleanups = [];
  }

  _stripCheckoutColonInNode(root) {
    const btn = root.querySelector('.ab-dynamic-bundle-checkout-button');
    if (!btn) return;
    const firstSpan = btn.querySelector('span');
    if (!firstSpan) return;
    const labelSpan = firstSpan.querySelector('span');
    if (!labelSpan) return;
    const txt = (labelSpan.textContent || '').trim();
    if (/^checkout:$/i.test(txt) || /^checkout\s*:$/i.test(txt)) {
      labelSpan.textContent = txt.replace(/:\s*$/,'');
    }
  }

  _wireCheckoutCloneInteractions(clone) {
    const btnClone = clone.querySelector('.ab-dynamic-bundle-checkout-button');
    const selClone = clone.querySelector('.ab-selling-plan-field-dropdown');
    if (btnClone) {
      const onClick = (e) => {
        e.preventDefault(); e.stopPropagation();
        const src = this._findCheckoutSourceInThisCE();
        if (!src) return;
        const btnSrc = src.querySelector('.ab-dynamic-bundle-checkout-button');
        if (!btnSrc) return;
        if (btnSrc.disabled || btnSrc.getAttribute('aria-disabled') === 'true') return;
        btnSrc.click();
      };
      btnClone.addEventListener('click', onClick, { passive: false });
      this._checkoutCloneCleanups.push(() => {
        btnClone.removeEventListener('click', onClick, { passive: false });
      });
    }
    if (selClone) {
      const onChange = (e) => {
        const src = this._findCheckoutSourceInThisCE();
        if (!src) return;
        const selSrc = src.querySelector('.ab-selling-plan-field-dropdown');
        if (!selSrc) return;
        const newVal = selClone.value;
        if (selSrc.value !== newVal) {
          selSrc.value = newVal;
          const evt1 = new Event('input', { bubbles: true });
          const evt2 = new Event('change', { bubbles: true });
          selSrc.dispatchEvent(evt1);
          selSrc.dispatchEvent(evt2);
        } else {
          const evt = new Event('change', { bubbles: true });
          selSrc.dispatchEvent(evt);
        }
      };
      selClone.addEventListener('change', onChange);
      selClone.addEventListener('input', onChange);
      this._checkoutCloneCleanups.push(() => {
        selClone.removeEventListener('change', onChange);
        selClone.removeEventListener('input', onChange);
      });
    }
  }

  _syncCheckout(force = false) {
    const target = this._getCheckoutTargetInThisCE();
    const source = this._findCheckoutSourceInThisCE();
    if (!target) return;
    if (!source) {
      this._clearCheckoutDelay();
      this._detachCheckoutCloneHandlers();
      target.replaceChildren();
      return;
    }
    if (!force) return;
    this._clearCheckoutDelay();
    this._checkoutDelayTimer = setTimeout(() => {
      this._checkoutDelayTimer = 0;
      this._detachCheckoutCloneHandlers();
      const clone = this._cloneCheckoutClean(source);
      this._stripCheckoutColonInNode(clone);
      this._wireCheckoutCloneInteractions(clone);
      target.replaceChildren(clone);
    }, 50);
  }

  _getSubtotalTargetInThisCE() {
    return this.querySelector('.hdt-ezz-bundle-subtotal');
  }

  _syncSubtotalFromCheckout() {
    const target = this._getSubtotalTargetInThisCE();
    if (!target) return;
    const src = this._findCheckoutSourceInThisCE();
    if (!src) { target.replaceChildren(); return; }
    const btn = src.querySelector('.ab-dynamic-bundle-checkout-button');
    if (!btn) { target.replaceChildren(); return; }

    const rootSpan = btn.querySelector('span');
    if (!rootSpan) { target.replaceChildren(); return; }

    const clone = rootSpan.cloneNode(true);

    const isCheckoutLabel = (text) => {
      const t = (text || '').replace(/\u00a0/g,' ').trim().toLowerCase();
      return t === 'checkout' || t === 'checkout:' || /^checkout\s*:?\s*$/.test(t);
    };

    Array.from(clone.querySelectorAll('span')).forEach(s => {
      if (isCheckoutLabel(s.textContent)) s.remove();
    });

    const walker = document.createTreeWalker(clone, NodeFilter.SHOW_TEXT, null);
    const toRemove = [];
    while (walker.nextNode()) {
      const n = walker.currentNode;
      if (isCheckoutLabel(n.textContent)) toRemove.push(n);
    }
    toRemove.forEach(n => n.parentNode && n.parentNode.removeChild(n));

    target.replaceChildren(clone);
  }
}
customElements.define('hdt-ezz-bundle', HdtEzzBundle);

class HdtProductFormInputWrap extends HTMLElement {
  constructor() {
    super();
    this._onChange = this._onChange.bind(this);
    this._observer = null;
  }

  connectedCallback() {
    this.addEventListener('change', this._onChange, true);
    this._observer = new MutationObserver(() => this._update());
    this._observer.observe(this, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['checked', 'value', 'data-show-val']
    });

    this._update();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this._onChange, true);
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
  }

  _norm(str) {
    return (str || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  _currentQuantityValue() {
    const checked = this.querySelector('input[name="Quantity"]:checked');
    return checked ? this._norm(checked.value) : null;
  }

  _update() {
    const current = this._currentQuantityValue();
    const rows = this.querySelectorAll('.hdt-qty-chosen-desc');

    rows.forEach(row => {
      const list = String(row.getAttribute('data-show-val') || '')
        .split(',')
        .map(s => this._norm(s))
        .filter(Boolean);

      const shouldShow = !!current && list.includes(current);
      row.classList.toggle('hdt-qty-desc-current', shouldShow);
    });
  }

  _onChange(e) {
    const t = e.target;
    if (t && t.matches('input[name="Quantity"]')) {
      queueMicrotask(() => this._update());
    }
  }
}

customElements.define('hdt-product-form-input-wrap', HdtProductFormInputWrap);

// Geo Location (Locator page)
(() => {
  if (window.__hdtGeoBtnOnceV2) return;
  window.__hdtGeoBtnOnceV2 = true;

  const SELECTOR_CONTAINER = ".sl-search-bar";
  const BTN_CLASS = "hdt-enable-geo-location";
  const BTN_TEXT = "Use my current location";

  let inserted = false;
  let observer = null;
  let timeoutId = null;

  const cleanup = () => {
    if (observer) { observer.disconnect(); observer = null; }
    if (timeoutId) { clearTimeout(timeoutId); timeoutId = null; }
  };

  const insertButton = (container) => {
    if (inserted) return;
    if (container.querySelector(`.${BTN_CLASS}`)) {
      inserted = true;
      console.debug("[geo] Đã thấy sẵn nút trong", SELECTOR_CONTAINER);
      cleanup();
      return;
    }

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = BTN_CLASS;
    btn.textContent = BTN_TEXT;

    btn.addEventListener("click", () => {
      const toggle = document.querySelector(".sl-my-location-toggle");
      if (toggle) {
        toggle.click();
        console.debug("[geo] Đã click .sl-my-location-toggle (ngay lập tức).");
      } else {
        console.warn("[geo] Chưa thấy .sl-my-location-toggle; theo dõi 5s để click khi xuất hiện.");
        const tempObs = new MutationObserver((_m, ob) => {
          const late = document.querySelector(".sl-my-location-toggle");
          if (late) {
            late.click();
            ob.disconnect();
            console.debug("[geo] Đã click .sl-my-location-toggle (xuất hiện muộn).");
          }
        });
        tempObs.observe(document.documentElement, { childList: true, subtree: true });
        setTimeout(() => tempObs.disconnect(), 5000);
      }
    });

    container.appendChild(btn);
    inserted = true;
    console.debug("[geo] Đã chèn nút vào", SELECTOR_CONTAINER);
    cleanup();
  };

  const tryInsert = () => {
    const container = document.querySelector(SELECTOR_CONTAINER);
    if (container) {
      insertButton(container);
    }
    if (!inserted) {
      observer = new MutationObserver(() => {
        const c = document.querySelector(SELECTOR_CONTAINER);
        if (c) insertButton(c);
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  };

  timeoutId = setTimeout(() => {
    if (!inserted) {
      cleanup();
      console.info("[geo] Dừng: Không thấy", SELECTOR_CONTAINER, "sau 10s, ngưng script để tiết kiệm tài nguyên.");
    }
  }, 10000);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", tryInsert, { once: true });
  } else {
    tryInsert();
  }
})();


// Collection Subscription ================
class HdtEzzShspOld extends HTMLElement {
  constructor() {
    super();
    this._ac = new AbortController();
    this._mo = null;
    this._busy = false;
    this._autoClicked = new WeakSet();
    this._initialTriggered = false;
    this._stepDelay = 10;
  }

  connectedCallback() {
    this.$switch = this.querySelector('.hdt-switch-input');
    if (!this.$switch) {
      console.warn('[hdt-ezz-shsp] Missing .hdt-switch-input inside the element.');
      return;
    }

    this.$switch.addEventListener('change', () => this._handleToggle(), { signal: this._ac.signal });
    this._startObserver();
    this._syncDeliveryTextVisibility(this.$switch.checked);
    const anyNow = this._queryAllCurrent().length > 0;
    if (anyNow) {
      this._initialTriggered = true;
      this._handleToggle();
    }
  }

  disconnectedCallback() {
    try { this._ac.abort(); } catch {}
    if (this._mo) { try { this._mo.disconnect(); } catch {} }
  }

  _showNode(el) {
    const prev = el.dataset.hdtPrevDisplay ?? '';
    if (prev) el.style.display = prev; else el.style.removeProperty('display');
    el.removeAttribute('hidden');
    el.setAttribute('aria-hidden', 'false');
  }

  _hideNode(el) {
    if (!('hdtPrevDisplay' in el.dataset)) {
      el.dataset.hdtPrevDisplay = el.style.display || '';
    }
    el.style.display = 'none';
    el.setAttribute('hidden', '');
    el.setAttribute('aria-hidden', 'true');
  }

  _applyDeliveryVisibilityTo(nodes, show) {
    if (!nodes || !nodes.length) return;
    for (const el of nodes) {
      if (!(el instanceof HTMLElement)) continue;
      show ? this._showNode(el) : this._hideNode(el);
    }
  }

  _syncDeliveryTextVisibility(show) {
    const nodes = Array.from(document.querySelectorAll(
      ".hdt-shop-content .hdt-product-card__delivery-text"
    ));
    this._applyDeliveryVisibilityTo(nodes, show);
    console.debug('[hdt-ezz-shsp] delivery text ->', show ? 'SHOW' : 'HIDE', '| nodes:', nodes.length);
  }

  _sleep(ms) { return new Promise(r => setTimeout(r, ms)); }

  _setBusy(on) {
    this._busy = !!on;
    this.$switch.disabled = !!on;
    this.$switch.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  _queryGroup(kind) {
    const sel = kind === 'sub'
      ? ".hdt-shop-content .appstle_subscription_radio_wrapper input[name='selling_plan']"
      : ".hdt-shop-content .appstle_one_time_details_wrapper input[name='selling_plan']";
    return Array.from(document.querySelectorAll(sel));
  }

  _queryAllCurrent() {
    return [
      ...this._queryGroup('sub'),
      ...this._queryGroup('ot')
    ];
  }

  async _clickBatch(inputs) {
    if (!inputs.length) return;
    this._setBusy(true);
    console.debug('[hdt-ezz-shsp] batch start, items:', inputs.length);
    for (const el of inputs) {
      try { el.click(); } catch {}
      await this._sleep(this._stepDelay); 
    }
    this._setBusy(false);
    console.debug('[hdt-ezz-shsp] batch end');
  }

  async _handleToggle() {
    if (this._busy) {
      console.debug('[hdt-ezz-shsp] toggle ignored (busy)');
      return;
    }
    const wantSub = this.$switch.checked;
    this._syncDeliveryTextVisibility(wantSub);
    const targets = wantSub ? this._queryGroup('sub') : this._queryGroup('ot');
    console.debug('[hdt-ezz-shsp] toggle ->', wantSub ? 'SUBSCRIBE' : 'ONE-TIME', '| targets:', targets.length);
    await this._clickBatch(targets);
  }

  _startObserver() {
    this._mo = new MutationObserver(mutations => {
      let newRadios = [];
      let newDeliveryTexts = [];

      const collectFrom = (el) => {
        const inShop = el.matches?.('.hdt-shop-content') || el.closest?.('.hdt-shop-content');
        if (!inShop) return;
        if (el.matches?.("input[name='selling_plan']")) {
          if (el.closest('.appstle_subscription_radio_wrapper') || el.closest('.appstle_one_time_details_wrapper')) {
            newRadios.push(el);
          }
        }
        newRadios.push(
          ...el.querySelectorAll?.(
            ".appstle_subscription_radio_wrapper input[name='selling_plan'], " +
            ".appstle_one_time_details_wrapper input[name='selling_plan']"
          ) || []
        );

        if (el.matches?.('.hdt-product-card__delivery-text')) newDeliveryTexts.push(el);
        newDeliveryTexts.push(
          ...el.querySelectorAll?.('.hdt-product-card__delivery-text') || []
        );
      };

      for (const m of mutations) {
        if (!m.addedNodes || m.addedNodes.length === 0) continue;
        m.addedNodes.forEach(node => {
          if (node instanceof HTMLElement) collectFrom(node);
        });
      }

      newRadios = Array.from(new Set(newRadios)).filter(n => !this._autoClicked.has(n));
      newDeliveryTexts = Array.from(new Set(newDeliveryTexts));
      if (newDeliveryTexts.length) {
        this._applyDeliveryVisibilityTo(newDeliveryTexts, this.$switch.checked);
        console.debug('[hdt-ezz-shsp] delivery text (new) ->', this.$switch.checked ? 'SHOW' : 'HIDE', '| nodes:', newDeliveryTexts.length);
      }

      if (newRadios.length) {
        if (!this._initialTriggered) {
          this._initialTriggered = true;
          console.debug('[hdt-ezz-shsp] first Appstle radios appeared -> full sync');
          this._handleToggle(); 
          newRadios.forEach(n => this._autoClicked.add(n));
        } else {
          const wantSub = this.$switch.checked;
          const subset = newRadios.filter(el =>
            wantSub
              ? !!el.closest('.appstle_subscription_radio_wrapper')
              : !!el.closest('.appstle_one_time_details_wrapper')
          );
          if (subset.length) {
            console.debug('[hdt-ezz-shsp] new radios appeared -> click subset:', subset.length);
            this._clickBatch(subset); 
            subset.forEach(n => this._autoClicked.add(n));
          }
        }
      }
    });

    this._mo.observe(document.body, { childList: true, subtree: true });
  }
}

//  customElements.define('hdt-ezz-shsp', HdtEzzShsp);

class HdtEzzShsp extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
    this.onToggle = this.onToggle.bind(this);
    this.mo = null;
    this.switchEl = null;
    this._dirtyCards = new Set();
    this._flushTimer = null;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    this.switchEl = this.querySelector('.hdt-switch-input');
    if (this.switchEl) this.switchEl.addEventListener('change', this.onToggle, { passive: true });
    this.backupAllCardsOriginalPrices();
    this.updateAllCards(this.isChecked());
    this.setupObserver();
  }

  disconnectedCallback() {
    if (this.switchEl) this.switchEl.removeEventListener('change', this.onToggle);
    if (this.mo) this.mo.disconnect();
    if (this._flushTimer) clearTimeout(this._flushTimer);
  }

  isChecked() {
    return !!(this.switchEl && this.switchEl.checked);
  }

  onToggle() {
    this.updateAllCards(this.isChecked());
  }

  setupObserver() {
    const container = document.querySelector('.hdt-shop-content');
    if (!container) return;

    this.mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'data-product-data') {
          const card = m.target.closest?.('.hdt-card-product');
          if (card) {
            this.ensureBackups(card);
            this.markCardDirty(card);
          }
          continue;
        }
        if (m.type === 'childList' && m.addedNodes?.length) {
          for (const node of m.addedNodes) {
            if (!(node instanceof Element)) continue;

            if (node.matches('.hdt-card-product')) {
              this.ensureBackups(node);
              this.markCardDirty(node);
              continue;
            }

            const isAppstleish =
              node.matches?.('.appstle_stand_alone_price_display_selector, [class^="appstle_"], [class*=" appstle_"]') ||
              node.querySelector?.('.appstle_stand_alone_price_display_selector, [class^="appstle_"], [class*=" appstle_"]');

            if (isAppstleish) {
              const card = node.closest?.('.hdt-card-product') || node.querySelector?.('.hdt-card-product');
              if (card) {
                this.ensureBackups(card);
                this.markCardDirty(card);
              }
            }

            const innerCard = node.querySelector?.('.hdt-card-product');
            if (innerCard) {
              this.ensureBackups(innerCard);
              this.markCardDirty(innerCard);
            }
          }
        }
      }
    });

    this.mo.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-product-data']
    });
  }

  markCardDirty(card) {
    this._dirtyCards.add(card);
    this.scheduleFlush();
  }

  scheduleFlush() {
    if (this._flushTimer) return;
    this._flushTimer = setTimeout(() => {
      const checked = this.isChecked();
      for (const card of this._dirtyCards) {
        this.applyUpdate(card, checked);
      }
      this._dirtyCards.clear();
      this._flushTimer = null;
    }, 50);
  }

  updateAllCards(checked) {
    const cards = document.querySelectorAll('.hdt-shop-content .hdt-card-product');
    cards.forEach((card) => {
      this.ensureBackups(card);
      this.applyUpdate(card, checked);
    });
  }

  applyUpdate(card, checked) {
    this.toggleDeliveryText(card, checked);
    this.updateCardPrice(card, checked);
  }

  toggleDeliveryText(card, checked) {
    const el = card.querySelector('.hdt-product-card__delivery-text');
    if (!el) return;
    el.style.display = checked ? 'block' : 'none';
  }

  updateCardPrice(card, checked) {
    const dataEl = card.querySelector('.appstle_stand_alone_price_display_selector[data-product-data]');
    if (!dataEl) {
      this.restoreOriginalPrices(card);
      return;
    }

    let productData = null;
    try {
      productData = JSON.parse(dataEl.getAttribute('data-product-data'));
    } catch {
      this.restoreOriginalPrices(card);
      return;
    }

    const { cents, ok } = this.computeCents(productData, checked);
    const moneyEls = card.querySelectorAll('.hdt-price .hdt-money');

    if (!ok || typeof cents !== 'number') {
      this.restoreOriginalPrices(card);
      return;
    }

    moneyEls.forEach((mEl) => {
      const original = this.getOriginalText(mEl);
      const fmt = this.parseFormat(original);
      const next = this.formatFromCents(cents, { decimalChar: fmt.decimalChar, groupChar: fmt.groupChar });
      mEl.textContent = `${fmt.prefix}${next}${fmt.suffix}`;
    });
  }

  computeCents(pd, checked) {
    if (!pd || typeof pd !== 'object') return { cents: null, ok: false };

    const variants = Array.isArray(pd.variants) ? pd.variants : [];

    if (checked) {
      let min = Infinity, found = false;
      for (const v of variants) {
        const packs = this.getPackCount(v?.option1);
        const spas = v && Array.isArray(v.selling_plan_allocations) ? v.selling_plan_allocations : [];
        for (const spa of spas) {
          if (spa && typeof spa.price === 'number') {
            let c = spa.price;
            if (packs && packs > 0) c = Math.round(c / packs);
            if (c < min) { min = c; found = true; }
          }
        }
      }
      return { cents: found ? min : null, ok: found };
    } else {
      let min = Infinity, found = false;
      for (const v of variants) {
        if (v && typeof v.price === 'number') {
          const packs = this.getPackCount(v?.option1);
          let c = v.price;
          if (packs && packs > 0) c = Math.round(c / packs);
          if (c < min) { min = c; found = true; }
        }
      }
      if (!found) {
        const ok = typeof pd.price === 'number';
        return { cents: ok ? pd.price : null, ok };
      }
      return { cents: min, ok: true };
    }
  }

  getPackCount(option1) {
    if (typeof option1 !== 'string') return null;
    const m = option1.match(/\b(\d+)\s*pack(s)?\b/i);
    if (!m) return null;
    const n = parseInt(m[1], 10);
    return Number.isFinite(n) && n > 0 ? n : null;
    }

  backupAllCardsOriginalPrices() {
    const cards = document.querySelectorAll('.hdt-shop-content .hdt-card-product');
    cards.forEach((card) => this.ensureBackups(card));
  }

  ensureBackups(card) {
    const moneyEls = card.querySelectorAll('.hdt-price .hdt-money');
    moneyEls.forEach((mEl) => {
      if (!mEl.hasAttribute('data-hdt-orig-money')) {
        const txt = (mEl.textContent || '').trim();
        mEl.setAttribute('data-hdt-orig-money', txt);
      }
    });
  }

  restoreOriginalPrices(card) {
    const moneyEls = card.querySelectorAll('.hdt-price .hdt-money');
    moneyEls.forEach((mEl) => {
      const orig = this.getOriginalText(mEl);
      if (orig != null) mEl.textContent = orig;
    });
  }

  getOriginalText(mEl) {
    return mEl.getAttribute('data-hdt-orig-money') ?? (mEl.textContent || '').trim();
  }

  parseFormat(str) {
    let prefix = '', suffix = '', numeric = '';
    if (str) {
      const m = str.match(/^(\D*)([\d.,\s]+)(.*)$/);
      if (m) { prefix = m[1] ?? ''; numeric = (m[2] ?? '').trim(); suffix = m[3] ?? ''; }
    }
    let decimalChar = '.', groupChar = '';
    if (numeric) {
      const lastDot = numeric.lastIndexOf('.');
      const lastComma = numeric.lastIndexOf(',');
      if (lastDot === -1 && lastComma === -1) { decimalChar = '.'; groupChar = ''; }
      else if (lastDot > lastComma) { decimalChar = '.'; groupChar = (lastComma !== -1) ? ',' : ''; }
      else { decimalChar = ','; groupChar = (lastDot !== -1) ? '.' : ''; }
      if ((lastDot !== -1) ^ (lastComma !== -1)) {
        const sep = (lastDot !== -1) ? '.' : ',';
        const tail = numeric.slice(numeric.lastIndexOf(sep) + 1);
        if (/^\d{2}$/.test(tail)) { decimalChar = sep; groupChar = ''; }
      }
    }
    return { prefix, suffix, decimalChar, groupChar };
  }

  formatFromCents(cents, { decimalChar = '.', groupChar = '' } = {}) {
    const val = (cents / 100).toFixed(2);
    let [intPart, decPart] = val.split('.');
    if (groupChar) intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, groupChar);
    const decimal = decPart ? (decimalChar + decPart) : '';
    return intPart + decimal;
  }
}
customElements.define('hdt-ezz-shsp', HdtEzzShsp);

document.querySelector('.hdt-select.hdt-select--policy')
?.addEventListener('change', e => {
  const opt = e.target.selectedOptions?.[0];
  const url = opt?.dataset?.href || opt?.value;
  if (url) location.assign(url);
});

// ========================================

const inputCutom = document.querySelector('#hdt-custom-checkbox-use-address-as-billing');
if(inputCutom) {
  const inputBillingAddress = document.querySelector('.hdt-input[name="address[address2]"]:not([disabled])');
  const oldValue = inputBillingAddress.value;
  inputCutom.addEventListener('change', (e) => {
    const inputBillingAddress = document.querySelector('.hdt-input[name="address[address2]"]:not([disabled])');
    const inputShippingAddress = document.querySelector('.hdt-input[name="address[address1]"]:not([disabled])');
    console.log(e.target.checked);
    const input = document.querySelector('.hdt-input');
    if(e.target.checked) {
      inputBillingAddress.value = inputShippingAddress.value;
    } else {
      inputBillingAddress.value = oldValue;
    }
  });
}
